export const americas = [
  {
    name: {
      common: 'Guatemala',
      official: 'Republic of Guatemala',
      nativeName: {
        spa: { official: 'República de Guatemala', common: 'Guatemala' }
      }
    },
    tld: ['.gt'],
    cca2: 'GT',
    ccn3: '320',
    cca3: 'GTM',
    cioc: 'GUA',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { GTQ: { name: 'Guatemalan quetzal', symbol: 'Q' } },
    idd: { root: '+5', suffixes: ['02'] },
    capital: ['Guatemala City'],
    altSpellings: ['GT'],
    region: 'Americas',
    subregion: 'Central America',
    languages: { spa: 'Spanish' },
    translations: {
      ara: { official: 'جمهورية غواتيمالا', common: 'غواتيمالا' },
      bre: { official: 'Republik Guatemala', common: 'Guatemala' },
      ces: { official: 'Republika Guatemala', common: 'Guatemala' },
      cym: { official: 'Republic of Guatemala', common: 'Guatemala' },
      deu: { official: 'Republik Guatemala', common: 'Guatemala' },
      est: { official: 'Guatemala Vabariik', common: 'Guatemala' },
      fin: { official: 'Guatemalan tasavalta', common: 'Guatemala' },
      fra: { official: 'République du Guatemala', common: 'Guatemala' },
      hrv: { official: 'Republika Gvatemala', common: 'Gvatemala' },
      hun: { official: 'Guatemalai Köztársaság', common: 'Guatemala' },
      ita: { official: 'Repubblica del Guatemala', common: 'Guatemala' },
      jpn: { official: 'グアテマラ共和国', common: 'グアテマラ' },
      kor: { official: '과테말라 공화국', common: '과테말라' },
      nld: { official: 'Republiek Guatemala', common: 'Guatemala' },
      per: { official: 'جمهوری گواتِمالا', common: 'گواتِمالا' },
      pol: { official: 'Republika Gwatemali', common: 'Gwatemala' },
      por: { official: 'República da Guatemala', common: 'Guatemala' },
      rus: { official: 'Республика Гватемала', common: 'Гватемала' },
      slk: { official: 'Guatemalská republika', common: 'Guatemala' },
      spa: { official: 'República de Guatemala', common: 'Guatemala' },
      swe: { official: 'Republiken Guatemala', common: 'Guatemala' },
      tur: { official: 'Guatemala Cumhuriyeti', common: 'Guatemala' },
      urd: { official: 'جمہوریہ گواتیمالا', common: 'گواتیمالا' },
      zho: { official: '危地马拉共和国', common: '危地马拉' }
    },
    latlng: [15.5, -90.25],
    landlocked: false,
    borders: ['BLZ', 'SLV', 'HND', 'MEX'],
    area: 108889.0,
    demonyms: {
      eng: { f: 'Guatemalan', m: 'Guatemalan' },
      fra: { f: 'Guatémaltèque', m: 'Guatémaltèque' }
    },
    flag: '\uD83C\uDDEC\uD83C\uDDF9',
    maps: {
      googleMaps: 'https://goo.gl/maps/JoRAbem4Hxb9FYbVA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/1521463'
    },
    population: 16858333,
    gini: { 2014: 48.3 },
    fifa: 'GUA',
    car: { signs: ['GCA'], side: 'right' },
    timezones: ['UTC-06:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/gt.png',
      svg: 'https://flagcdn.com/gt.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/gt.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/gt.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [14.62, -90.52] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Barbados',
      official: 'Barbados',
      nativeName: { eng: { official: 'Barbados', common: 'Barbados' } }
    },
    tld: ['.bb'],
    cca2: 'BB',
    ccn3: '052',
    cca3: 'BRB',
    cioc: 'BAR',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { BBD: { name: 'Barbadian dollar', symbol: '$' } },
    idd: { root: '+1', suffixes: ['246'] },
    capital: ['Bridgetown'],
    altSpellings: ['BB'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'باربادوس', common: 'باربادوس' },
      bre: { official: 'Barbados', common: 'Barbados' },
      ces: { official: 'Barbados', common: 'Barbados' },
      cym: { official: 'Barbados', common: 'Barbados' },
      deu: { official: 'Barbados', common: 'Barbados' },
      est: { official: 'Barbados', common: 'Barbados' },
      fin: { official: 'Barbados', common: 'Barbados' },
      fra: { official: 'Barbade', common: 'Barbade' },
      hrv: { official: 'Barbados', common: 'Barbados' },
      hun: { official: 'Barbados', common: 'Barbados' },
      ita: { official: 'Barbados', common: 'Barbados' },
      jpn: { official: 'バルバドス', common: 'バルバドス' },
      kor: { official: '바베이도스', common: '바베이도스' },
      nld: { official: 'Barbados', common: 'Barbados' },
      per: { official: 'باربادوس', common: 'باربادوس' },
      pol: { official: 'Barbados', common: 'Barbados' },
      por: { official: 'Barbados', common: 'Barbados' },
      rus: { official: 'Барбадос', common: 'Барбадос' },
      slk: { official: 'Barbados', common: 'Barbados' },
      spa: { official: 'Barbados', common: 'Barbados' },
      swe: { official: 'Barbados', common: 'Barbados' },
      tur: { official: 'Barbados', common: 'Barbados' },
      urd: { official: 'بارباڈوس', common: 'بارباڈوس' },
      zho: { official: '巴巴多斯', common: '巴巴多斯' }
    },
    latlng: [13.16666666, -59.53333333],
    landlocked: false,
    area: 430.0,
    demonyms: {
      eng: { f: 'Barbadian', m: 'Barbadian' },
      fra: { f: 'Barbadienne', m: 'Barbadien' }
    },
    flag: '\uD83C\uDDE7\uD83C\uDDE7',
    maps: {
      googleMaps: 'https://goo.gl/maps/2m36v8STvbGAWd9c7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/547511'
    },
    population: 287371,
    fifa: 'BRB',
    car: { signs: ['BDS'], side: 'left' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/bb.png',
      svg: 'https://flagcdn.com/bb.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/bb.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/bb.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [13.1, -59.62] },
    postalCode: { format: 'BB#####', regex: '^(?:BB)*(\\d{5})$' }
  },
  {
    name: {
      common: 'Guadeloupe',
      official: 'Guadeloupe',
      nativeName: { fra: { official: 'Guadeloupe', common: 'Guadeloupe' } }
    },
    tld: ['.gp'],
    cca2: 'GP',
    ccn3: '312',
    cca3: 'GLP',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { EUR: { name: 'Euro', symbol: '€' } },
    idd: { root: '+5', suffixes: ['90'] },
    capital: ['Basse-Terre'],
    altSpellings: ['GP', 'Gwadloup'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { fra: 'French' },
    translations: {
      ara: { official: 'غوادلوب', common: 'غوادلوب' },
      bre: { official: 'Gwadeloup', common: 'Gwadeloup' },
      ces: { official: 'Guadeloupe', common: 'Guadeloupe' },
      cym: { official: 'Guadeloupe', common: 'Guadeloupe' },
      deu: { official: 'Guadeloupe', common: 'Guadeloupe' },
      est: {
        official: 'Guadeloupe’i ja sõltkondade departemang',
        common: 'Guadeloupe'
      },
      fin: { official: 'Guadeloupen departmentti', common: 'Guadeloupe' },
      fra: { official: 'Guadeloupe', common: 'Guadeloupe' },
      hrv: { official: 'Gvadalupa', common: 'Gvadalupa' },
      hun: { official: 'Guadeloupe', common: 'Guadeloupe' },
      ita: { official: 'Guadeloupe', common: 'Guadeloupa' },
      jpn: { official: 'グアドループ島', common: 'グアドループ' },
      kor: { official: '과들루프', common: '과들루프' },
      nld: { official: 'Guadeloupe', common: 'Guadeloupe' },
      per: { official: 'گوادلوپ', common: 'گوادلوپ' },
      pol: { official: 'Gwadelupa', common: 'Gwadelupa' },
      por: { official: 'Guadalupe', common: 'Guadalupe' },
      rus: { official: 'Гваделупа', common: 'Гваделупа' },
      slk: { official: 'Guadeloupe', common: 'Guadeloupe' },
      spa: { official: 'Guadalupe', common: 'Guadalupe' },
      swe: { official: 'Guadeloupe', common: 'Guadeloupe' },
      tur: { official: 'Guadeloupe', common: 'Guadeloupe' },
      urd: { official: 'گواڈیلوپ', common: 'گواڈیلوپ' },
      zho: { official: '瓜德罗普岛', common: '瓜德罗普岛' }
    },
    latlng: [16.25, -61.583333],
    landlocked: false,
    area: 1628.0,
    demonyms: {
      eng: { f: 'Guadeloupian', m: 'Guadeloupian' },
      fra: { f: 'Guadeloupéenne', m: 'Guadeloupéen' }
    },
    flag: '\uD83C\uDDEC\uD83C\uDDF5',
    maps: {
      googleMaps: 'https://goo.gl/maps/Dy9R2EufJtoWm8UN9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/7109289'
    },
    population: 400132,
    car: { signs: ['F'], side: 'right' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/gp.png',
      svg: 'https://flagcdn.com/gp.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/gp.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/gp.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [16.03, -61.73] },
    postalCode: { format: '#####', regex: '^((97|98)\\d{3})$' }
  },
  {
    name: {
      common: 'French Guiana',
      official: 'Guiana',
      nativeName: { fra: { official: 'Guyane', common: 'Guyane française' } }
    },
    tld: ['.gf'],
    cca2: 'GF',
    ccn3: '254',
    cca3: 'GUF',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { EUR: { name: 'Euro', symbol: '€' } },
    idd: { root: '+5', suffixes: ['94'] },
    capital: ['Cayenne'],
    altSpellings: ['GF', 'Guiana', 'Guyane'],
    region: 'Americas',
    subregion: 'South America',
    languages: { fra: 'French' },
    translations: {
      ara: { official: 'غويانا الفرنسية', common: 'غويانا' },
      bre: { official: "Gwiana C'hall", common: "Gwiana C'hall" },
      ces: { official: 'Francouzská Guyana', common: 'Francouzská Guyana' },
      cym: { official: 'Guiana', common: 'French Guiana' },
      deu: { official: 'Französisch-Guayana', common: 'Französisch-Guayana' },
      est: { official: 'Guajaana departemang', common: 'Prantsuse Guajaana' },
      fin: { official: 'Ranskan Guayana', common: 'Ranskan Guayana' },
      fra: { official: 'Guyane', common: 'Guyane' },
      hrv: { official: 'Gijana', common: 'Francuska Gvajana' },
      hun: { official: 'Francia Guyana', common: 'Francia Guyana' },
      ita: { official: 'Guiana', common: 'Guyana francese' },
      jpn: { official: 'ギアナ', common: 'フランス領ギアナ' },
      kor: { official: '프랑스령 기아나', common: '프랑스령 기아나' },
      nld: { official: 'Guyana', common: 'Frans-Guyana' },
      per: { official: 'گویان فرانسه', common: 'گویان فرانسه' },
      pol: { official: 'Gujana Francuska', common: 'Gujana Francuska' },
      por: { official: 'Guiana', common: 'Guiana Francesa' },
      rus: { official: 'Гвиана', common: 'Французская Гвиана' },
      slk: { official: 'Francúzska Guyana', common: 'Guyana' },
      spa: { official: 'Guayana', common: 'Guayana Francesa' },
      swe: { official: 'Franska Guyana', common: 'Franska Guyana' },
      tur: { official: 'Fransız Guyanası', common: 'Fransız Guyanası' },
      urd: { official: 'گیانا', common: 'فرانسیسی گیانا' },
      zho: { official: '法属圭亚那', common: '法属圭亚那' }
    },
    latlng: [4.0, -53.0],
    landlocked: false,
    borders: ['BRA', 'SUR'],
    area: 83534.0,
    demonyms: {
      eng: { f: 'Guianan', m: 'Guianan' },
      fra: { f: 'Guyanaise', m: 'Guyanais' }
    },
    flag: '\uD83C\uDDEC\uD83C\uDDEB',
    maps: {
      googleMaps: 'https://goo.gl/maps/NJawFwMzG7YtCrVP7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/2502058'
    },
    population: 254541,
    car: { signs: ['F'], side: 'right' },
    timezones: ['UTC-03:00'],
    continents: ['South America'],
    flags: {
      png: 'https://flagcdn.com/w320/gf.png',
      svg: 'https://flagcdn.com/gf.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/gf.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/gf.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [4.94, -52.33] },
    postalCode: { format: '#####', regex: '^((97|98)3\\d{2})$' }
  },
  {
    name: {
      common: 'Antigua and Barbuda',
      official: 'Antigua and Barbuda',
      nativeName: {
        eng: { official: 'Antigua and Barbuda', common: 'Antigua and Barbuda' }
      }
    },
    tld: ['.ag'],
    cca2: 'AG',
    ccn3: '028',
    cca3: 'ATG',
    cioc: 'ANT',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { XCD: { name: 'Eastern Caribbean dollar', symbol: '$' } },
    idd: { root: '+1', suffixes: ['268'] },
    capital: ["Saint John's"],
    altSpellings: ['AG'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'أنتيغوا وباربودا', common: 'أنتيغوا وباربودا' },
      bre: { official: 'Antigua ha Barbuda', common: 'Antigua ha Barbuda' },
      ces: { official: 'Antigua a Barbuda', common: 'Antigua a Barbuda' },
      cym: { official: 'Antigwa a Barbiwda', common: 'Antigwa a Barbiwda' },
      deu: { official: 'Antigua und Barbuda', common: 'Antigua und Barbuda' },
      est: { official: 'Antigua ja Barbuda', common: 'Antigua ja Barbuda' },
      fin: { official: 'Antigua ja Barbuda', common: 'Antigua ja Barbuda' },
      fra: { official: 'Antigua -et-Barbuda', common: 'Antigua-et-Barbuda' },
      hrv: { official: 'Antigva i Barbuda', common: 'Antigva i Barbuda' },
      hun: { official: 'Antigua és Barbuda', common: 'Antigua és Barbuda' },
      ita: { official: 'Antigua e Barbuda', common: 'Antigua e Barbuda' },
      jpn: {
        official: 'アンチグアバーブーダ',
        common: 'アンティグア・バーブーダ'
      },
      kor: { official: '앤티가 바부다', common: '앤티가 바부다' },
      nld: { official: 'Antigua en Barbuda', common: 'Antigua en Barbuda' },
      per: { official: 'آنتیگوا و باربودا', common: 'آنتیگوا و باربودا' },
      pol: { official: 'Antigua i Barbuda', common: 'Antigua i Barbuda' },
      por: { official: 'Antigua e Barbuda', common: 'Antígua e Barbuda' },
      rus: { official: 'Антигуа и Барбуда', common: 'Антигуа и Барбуда' },
      slk: { official: 'Antigua a Barbuda', common: 'Antigua a Barbuda' },
      spa: { official: 'Antigua y Barbuda', common: 'Antigua y Barbuda' },
      swe: { official: 'Antigua och Barbuda', common: 'Antigua och Barbuda' },
      tur: { official: 'Antigua ve Barbuda', common: 'Antigua ve Barbuda' },
      urd: { official: 'اینٹیگوا و باربوڈا', common: 'اینٹیگوا و باربوڈا' },
      zho: { official: '安提瓜和巴布达', common: '安提瓜和巴布达' }
    },
    latlng: [17.05, -61.8],
    landlocked: false,
    area: 442.0,
    demonyms: {
      eng: { f: 'Antiguan, Barbudan', m: 'Antiguan, Barbudan' },
      fra: { f: 'Antiguaise et barbudienne', m: 'Antiguaise et barbudien' }
    },
    flag: '\uD83C\uDDE6\uD83C\uDDEC',
    maps: {
      googleMaps: 'https://goo.gl/maps/fnye4wGJ1RzC9jpX9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/536900'
    },
    population: 97928,
    fifa: 'ATG',
    car: { signs: ['AG'], side: 'left' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/ag.png',
      svg: 'https://flagcdn.com/ag.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ag.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ag.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [17.12, -61.85] }
  },
  {
    name: {
      common: 'Paraguay',
      official: 'Republic of Paraguay',
      nativeName: {
        grn: { official: 'Tetã Paraguái', common: 'Paraguái' },
        spa: { official: 'República de Paraguay', common: 'Paraguay' }
      }
    },
    tld: ['.py'],
    cca2: 'PY',
    ccn3: '600',
    cca3: 'PRY',
    cioc: 'PAR',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { PYG: { name: 'Paraguayan guaraní', symbol: '₲' } },
    idd: { root: '+5', suffixes: ['95'] },
    capital: ['Asunción'],
    altSpellings: [
      'PY',
      'Republic of Paraguay',
      'República del Paraguay',
      'Tetã Paraguái'
    ],
    region: 'Americas',
    subregion: 'South America',
    languages: { grn: 'Guaraní', spa: 'Spanish' },
    translations: {
      ara: { official: 'جمهورية باراغواي', common: 'باراغواي' },
      bre: { official: 'Republik Paraguay', common: 'Paraguay' },
      ces: { official: 'Paraguayská republika', common: 'Paraguay' },
      cym: { official: 'Republic of Paraguay', common: 'Paraguay' },
      deu: { official: 'Republik Paraguay', common: 'Paraguay' },
      est: { official: 'Paraguay Vabariik', common: 'Paraguay' },
      fin: { official: 'Paraguayn tasavalta', common: 'Paraguay' },
      fra: { official: 'République du Paraguay', common: 'Paraguay' },
      hrv: { official: 'Republika Paragvaj', common: 'Paragvaj' },
      hun: { official: 'Paraguayi Köztársaság', common: 'Paraguay' },
      ita: { official: 'Repubblica del Paraguay', common: 'Paraguay' },
      jpn: { official: 'パラグアイ共和国', common: 'パラグアイ' },
      kor: { official: '파라과이 공화국', common: '파라과이' },
      nld: { official: 'Republiek Paraguay', common: 'Paraguay' },
      per: { official: 'جمهوری پاراگوئه', common: 'پاراگوئه' },
      pol: { official: 'Republika Paragwaju', common: 'Paragwaj' },
      por: { official: 'República do Paraguai', common: 'Paraguai' },
      rus: { official: 'Республика Парагвай', common: 'Парагвай' },
      slk: { official: 'Paraguajská republika', common: 'Paraguaj' },
      spa: { official: 'República de Paraguay', common: 'Paraguay' },
      swe: { official: 'Republiken Paraguay', common: 'Paraguay' },
      tur: { official: 'Paraguay Cumhuriyeti', common: 'Paraguay' },
      urd: { official: 'جمہوریہ پیراگوئے', common: 'پیراگوئے' },
      zho: { official: '巴拉圭共和国', common: '巴拉圭' }
    },
    latlng: [-23.0, -58.0],
    landlocked: true,
    borders: ['ARG', 'BOL', 'BRA'],
    area: 406752.0,
    demonyms: {
      eng: { f: 'Paraguayan', m: 'Paraguayan' },
      fra: { f: 'Paraguayenne', m: 'Paraguayen' }
    },
    flag: '\uD83C\uDDF5\uD83C\uDDFE',
    maps: {
      googleMaps: 'https://goo.gl/maps/JtnqG73WJn1Gx6mz6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/287077'
    },
    population: 7132530,
    gini: { 2019: 45.7 },
    fifa: 'PAR',
    car: { signs: ['PY'], side: 'right' },
    timezones: ['UTC-04:00'],
    continents: ['South America'],
    flags: {
      png: 'https://flagcdn.com/w320/py.png',
      svg: 'https://flagcdn.com/py.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/py.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/py.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-25.28, -57.57] },
    postalCode: { format: '####', regex: '^(\\d{4})$' }
  },
  {
    name: {
      common: 'Nicaragua',
      official: 'Republic of Nicaragua',
      nativeName: {
        spa: { official: 'República de Nicaragua', common: 'Nicaragua' }
      }
    },
    tld: ['.ni'],
    cca2: 'NI',
    ccn3: '558',
    cca3: 'NIC',
    cioc: 'NCA',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { NIO: { name: 'Nicaraguan córdoba', symbol: 'C$' } },
    idd: { root: '+5', suffixes: ['05'] },
    capital: ['Managua'],
    altSpellings: ['NI', 'Republic of Nicaragua', 'República de Nicaragua'],
    region: 'Americas',
    subregion: 'Central America',
    languages: { spa: 'Spanish' },
    translations: {
      ara: { official: 'جمهورية نيكاراغوا', common: 'نيكاراغوا' },
      bre: { official: 'Republik Nicaragua', common: 'Nicaragua' },
      ces: { official: 'Republika Nikaragua', common: 'Nikaragua' },
      cym: { official: 'Republic of Nicaragua', common: 'Nicaragua' },
      deu: { official: 'Republik Nicaragua', common: 'Nicaragua' },
      est: { official: 'Nicaragua Vabariik', common: 'Nicaragua' },
      fin: { official: 'Nicaraguan tasavalta', common: 'Nicaragua' },
      fra: { official: 'République du Nicaragua', common: 'Nicaragua' },
      hrv: { official: 'Republika Nikaragva', common: 'Nikaragva' },
      hun: { official: 'Nicaraguai Köztársaság', common: 'Nicaragua' },
      ita: { official: 'Repubblica del Nicaragua', common: 'Nicaragua' },
      jpn: { official: 'ニカラグア共和国', common: 'ニカラグア' },
      kor: { official: '니카라과 공화국', common: '니카라과' },
      nld: { official: 'Republiek Nicaragua', common: 'Nicaragua' },
      per: { official: 'جمهوری نیکاراگوئه', common: 'نیکاراگوئه' },
      pol: { official: 'Republika Nikaragui', common: 'Nikaragua' },
      por: { official: 'República da Nicarágua', common: 'Nicarágua' },
      rus: { official: 'Республика Никарагуа', common: 'Никарагуа' },
      slk: { official: 'Nikaragujská republika', common: 'Nikaragua' },
      spa: { official: 'República de Nicaragua', common: 'Nicaragua' },
      swe: { official: 'Republiken Nicaragua', common: 'Nicaragua' },
      tur: { official: 'Nikaragua Cumhuriyeti', common: 'Nikaragua' },
      urd: { official: 'جمہوریہ نکاراگوا', common: 'نکاراگوا' },
      zho: { official: '尼加拉瓜共和国', common: '尼加拉瓜' }
    },
    latlng: [13.0, -85.0],
    landlocked: false,
    borders: ['CRI', 'HND'],
    area: 130373.0,
    demonyms: {
      eng: { f: 'Nicaraguan', m: 'Nicaraguan' },
      fra: { f: 'Nicaraguayenne', m: 'Nicaraguayen' }
    },
    flag: '\uD83C\uDDF3\uD83C\uDDEE',
    maps: {
      googleMaps: 'https://goo.gl/maps/P77LaEVkKJKXneRC6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/287666'
    },
    population: 6624554,
    gini: { 2014: 46.2 },
    fifa: 'NCA',
    car: { signs: ['NIC'], side: 'right' },
    timezones: ['UTC-06:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/ni.png',
      svg: 'https://flagcdn.com/ni.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ni.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ni.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [12.13, -86.25] },
    postalCode: { format: '###-###-#', regex: '^(\\d{7})$' }
  },
  {
    name: {
      common: 'Honduras',
      official: 'Republic of Honduras',
      nativeName: {
        spa: { official: 'República de Honduras', common: 'Honduras' }
      }
    },
    tld: ['.hn'],
    cca2: 'HN',
    ccn3: '340',
    cca3: 'HND',
    cioc: 'HON',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { HNL: { name: 'Honduran lempira', symbol: 'L' } },
    idd: { root: '+5', suffixes: ['04'] },
    capital: ['Tegucigalpa'],
    altSpellings: ['HN', 'Republic of Honduras', 'República de Honduras'],
    region: 'Americas',
    subregion: 'Central America',
    languages: { spa: 'Spanish' },
    translations: {
      ara: { official: 'جمهورية هندوراس', common: 'هندوراس' },
      bre: { official: 'Republik Honduras', common: 'Honduras' },
      ces: { official: 'Honduraská republika', common: 'Honduras' },
      cym: { official: 'Republic of Honduras', common: 'Honduras' },
      deu: { official: 'Republik Honduras', common: 'Honduras' },
      est: { official: 'Hondurase Vabariik', common: 'Honduras' },
      fin: { official: 'Hondurasin tasavalta', common: 'Honduras' },
      fra: { official: 'République du Honduras', common: 'Honduras' },
      hrv: { official: 'Republika Honduras', common: 'Honduras' },
      hun: { official: 'Hondurasi Köztársaság', common: 'Honduras' },
      ita: { official: 'Repubblica di Honduras', common: 'Honduras' },
      jpn: { official: 'ホンジュラス共和国', common: 'ホンジュラス' },
      kor: { official: '온두라스 공화국', common: '온두라스' },
      nld: { official: 'Republiek Honduras', common: 'Honduras' },
      per: { official: 'جمهوری هندوراس', common: 'هُندوراس' },
      pol: { official: 'Republika Hondurasu', common: 'Honduras' },
      por: { official: 'República de Honduras', common: 'Honduras' },
      rus: { official: 'Республика Гондурас', common: 'Гондурас' },
      slk: { official: 'Honduraská republika', common: 'Honduras' },
      spa: { official: 'República de Honduras', common: 'Honduras' },
      swe: { official: 'Republiken Honduras', common: 'Honduras' },
      tur: { official: 'Honduras Cumhuriyeti', common: 'Honduras' },
      urd: { official: 'جمہوریہ ہونڈوراس', common: 'ہونڈوراس' },
      zho: { official: '洪都拉斯共和国', common: '洪都拉斯' }
    },
    latlng: [15.0, -86.5],
    landlocked: false,
    borders: ['GTM', 'SLV', 'NIC'],
    area: 112492.0,
    demonyms: {
      eng: { f: 'Honduran', m: 'Honduran' },
      fra: { f: 'Hondurienne', m: 'Hondurien' }
    },
    flag: '\uD83C\uDDED\uD83C\uDDF3',
    maps: {
      googleMaps: 'https://goo.gl/maps/BbeJK8Sk2VkMHbdF8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/287670'
    },
    population: 9904608,
    gini: { 2019: 48.2 },
    fifa: 'HON',
    car: { signs: ['HN'], side: 'right' },
    timezones: ['UTC-06:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/hn.png',
      svg: 'https://flagcdn.com/hn.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/hn.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/hn.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [14.1, -87.22] },
    postalCode: { format: '@@####', regex: '^([A-Z]{2}\\d{4})$' }
  },
  {
    name: {
      common: 'Saint Martin',
      official: 'Saint Martin',
      nativeName: { fra: { official: 'Saint-Martin', common: 'Saint-Martin' } }
    },
    tld: ['.fr', '.gp'],
    cca2: 'MF',
    ccn3: '663',
    cca3: 'MAF',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { EUR: { name: 'Euro', symbol: '€' } },
    idd: { root: '+5', suffixes: ['90'] },
    capital: ['Marigot'],
    altSpellings: [
      'MF',
      'Collectivity of Saint Martin',
      'Collectivité de Saint-Martin',
      'Saint Martin (French part)'
    ],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { fra: 'French' },
    translations: {
      ara: { official: 'سانت مارتن', common: 'سانت مارتن' },
      bre: { official: 'Saint-Martin', common: 'Saint-Martin' },
      ces: { official: 'Svatý Martin', common: 'Svatý Martin (Francie)' },
      cym: { official: 'Saint Martin', common: 'Saint Martin' },
      deu: { official: 'Saint-Martin', common: 'Saint-Martin' },
      est: { official: 'Saint-Martini ühendus', common: 'Saint-Martin' },
      fin: { official: 'Saint-Martin', common: 'Saint-Martin' },
      fra: { official: 'Saint-Martin', common: 'Saint-Martin' },
      hrv: { official: 'Saint Martin', common: 'Sveti Martin' },
      hun: { official: 'Saint-Martin Közösség', common: 'Saint-Martin' },
      ita: { official: 'saint Martin', common: 'Saint Martin' },
      jpn: {
        official: 'サンマルタン島',
        common: 'サン・マルタン（フランス領）'
      },
      kor: { official: '생마르탱', common: '생마르탱' },
      nld: { official: 'Saint Martin', common: 'Saint-Martin' },
      per: { official: 'سن مارتن', common: 'سن مارتن' },
      pol: { official: 'Wspólnota Saint-Martin', common: 'Saint-Martin' },
      por: { official: 'saint Martin', common: 'São Martinho' },
      rus: { official: 'Сен-Мартен', common: 'Сен-Мартен' },
      slk: { official: 'Saint-Martin', common: 'Saint-Martin' },
      spa: { official: 'Saint Martin', common: 'Saint Martin' },
      swe: {
        official: 'Förvaltningsområdet Saint-Martin',
        common: 'Saint-Martin'
      },
      tur: { official: 'Saint Martin', common: 'Saint Martin' },
      urd: { official: 'سینٹ مارٹن', common: 'سینٹ مارٹن' },
      zho: { official: '圣马丁', common: '圣马丁' }
    },
    latlng: [18.08333333, -63.95],
    landlocked: false,
    borders: ['SXM'],
    area: 53.0,
    demonyms: {
      eng: { f: 'Saint Martin Islander', m: 'Saint Martin Islander' },
      fra: { f: 'Saint-Martinoise', m: 'Saint-Martinois' }
    },
    flag: '\uD83C\uDDF2\uD83C\uDDEB',
    maps: {
      googleMaps: 'https://goo.gl/maps/P9ho9QuJ9EAR28JEA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/63064'
    },
    population: 38659,
    car: { signs: ['F'], side: 'right' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/mf.png',
      svg: 'https://flagcdn.com/mf.svg'
    },
    coatOfArms: {},
    startOfWeek: 'monday',
    capitalInfo: { latlng: [18.07, -63.08] },
    postalCode: { format: '### ###' }
  },
  {
    name: {
      common: 'Venezuela',
      official: 'Bolivarian Republic of Venezuela',
      nativeName: {
        spa: {
          official: 'República Bolivariana de Venezuela',
          common: 'Venezuela'
        }
      }
    },
    tld: ['.ve'],
    cca2: 'VE',
    ccn3: '862',
    cca3: 'VEN',
    cioc: 'VEN',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: {
      VES: { name: 'Venezuelan bolívar soberano', symbol: 'Bs.S.' }
    },
    idd: { root: '+5', suffixes: ['8'] },
    capital: ['Caracas'],
    altSpellings: [
      'VE',
      'Bolivarian Republic of Venezuela',
      'Venezuela, Bolivarian Republic of',
      'República Bolivariana de Venezuela'
    ],
    region: 'Americas',
    subregion: 'South America',
    languages: { spa: 'Spanish' },
    translations: {
      ara: { official: 'جمهورية فنزويلا البوليفارية', common: 'فنزويلا' },
      bre: { official: 'Republik Volivarian Venezuela', common: 'Venezuela' },
      ces: { official: 'Bolívarská republika Venezuela', common: 'Venezuela' },
      cym: {
        official: 'Bolivarian Republic of Venezuela',
        common: 'Venezuela'
      },
      deu: { official: 'Bolivarische Republik Venezuela', common: 'Venezuela' },
      est: { official: 'Venezuela Bolívari Vabariik', common: 'Venezuela' },
      fin: {
        official: 'Venezuelan bolivariaainen tasavalta',
        common: 'Venezuela'
      },
      fra: {
        official: 'République bolivarienne du Venezuela',
        common: 'Venezuela'
      },
      hrv: {
        official: 'BOLIVARIJANSKA Republika Venezuela',
        common: 'Venezuela'
      },
      hun: { official: 'Venezuelai Bolivári Köztársaság', common: 'Venezuela' },
      ita: {
        official: 'Repubblica Bolivariana del Venezuela',
        common: 'Venezuela'
      },
      jpn: {
        official: 'ベネズエラ·ボリバル共和国',
        common: 'ベネズエラ・ボリバル共和国'
      },
      kor: { official: '베네수엘라 볼리바르 공화국', common: '베네수엘라' },
      nld: {
        official: 'Bolivariaanse Republiek Venezuela',
        common: 'Venezuela'
      },
      per: { official: 'جمهوری بولیواری ونزوئلا', common: 'ونزوئلا' },
      pol: {
        official: 'Boliwariańska Republika Wenezueli',
        common: 'Wenezuela'
      },
      por: {
        official: 'República Bolivariana da Venezuela',
        common: 'Venezuela'
      },
      rus: {
        official: 'Боливарианская Республика Венесуэла',
        common: 'Венесуэла'
      },
      slk: {
        official: 'Venezuelská bolívarovská republika',
        common: 'Venezuela'
      },
      spa: {
        official: 'República Bolivariana de Venezuela',
        common: 'Venezuela'
      },
      swe: {
        official: 'Bolivarianska republiken Venezuela',
        common: 'Venezuela'
      },
      tur: { official: 'Bolivarcı Venezuela Cumhuriyeti', common: 'Venezuela' },
      urd: { official: 'جمہوریہ وینیزویلا', common: 'وینیزویلا' },
      zho: { official: '委内瑞拉玻利瓦尔共和国', common: '委内瑞拉' }
    },
    latlng: [8.0, -66.0],
    landlocked: false,
    borders: ['BRA', 'COL', 'GUY'],
    area: 916445.0,
    demonyms: {
      eng: { f: 'Venezuelan', m: 'Venezuelan' },
      fra: { f: 'Vénézuélienne', m: 'Vénézuélien' }
    },
    flag: '\uD83C\uDDFB\uD83C\uDDEA',
    maps: {
      googleMaps: 'https://goo.gl/maps/KLCwDN8sec7z2kse9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/272644'
    },
    population: 28435943,
    gini: { 2006: 44.8 },
    fifa: 'VEN',
    car: { signs: ['YV'], side: 'right' },
    timezones: ['UTC-04:00'],
    continents: ['South America'],
    flags: {
      png: 'https://flagcdn.com/w320/ve.png',
      svg: 'https://flagcdn.com/ve.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ve.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ve.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [10.48, -66.87] },
    postalCode: { format: '####', regex: '^(\\d{4})$' }
  },
  {
    name: {
      common: 'Costa Rica',
      official: 'Republic of Costa Rica',
      nativeName: {
        spa: { official: 'República de Costa Rica', common: 'Costa Rica' }
      }
    },
    tld: ['.cr'],
    cca2: 'CR',
    ccn3: '188',
    cca3: 'CRI',
    cioc: 'CRC',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { CRC: { name: 'Costa Rican colón', symbol: '₡' } },
    idd: { root: '+5', suffixes: ['06'] },
    capital: ['San José'],
    altSpellings: ['CR', 'Republic of Costa Rica', 'República de Costa Rica'],
    region: 'Americas',
    subregion: 'Central America',
    languages: { spa: 'Spanish' },
    translations: {
      ara: { official: 'جمهورية كوستاريكا', common: 'كوستاريكا' },
      bre: { official: 'Republik Costa Rica', common: 'Costa Rica' },
      ces: { official: 'Kostarická republika', common: 'Kostarika' },
      cym: { official: 'Gweriniaeth Costa Rica', common: 'Costa Rica' },
      deu: { official: 'Republik Costa Rica', common: 'Costa Rica' },
      est: { official: 'Costa Rica Vabariik', common: 'Costa Rica' },
      fin: { official: 'Costa Rican tasavalta', common: 'Costa Rica' },
      fra: { official: 'République du Costa Rica', common: 'Costa Rica' },
      hrv: { official: 'Republika Kostarika', common: 'Kostarika' },
      hun: { official: 'Costa Rica-i Köztársaság', common: 'Costa Rica' },
      ita: { official: 'Repubblica di Costa Rica', common: 'Costa Rica' },
      jpn: { official: 'コスタリカ共和国', common: 'コスタリカ' },
      kor: { official: '코스타리카 공화국', common: '코스타리카' },
      nld: { official: 'Republiek Costa Rica', common: 'Costa Rica' },
      per: { official: 'جمهوری کاستاریکا', common: 'کاستاریکا' },
      pol: { official: 'Republika Kostaryki', common: 'Kostaryka' },
      por: { official: 'República da Costa Rica', common: 'Costa Rica' },
      rus: { official: 'Республика Коста-Рика', common: 'Коста-Рика' },
      slk: { official: 'Kostarická republika', common: 'Kostarika' },
      spa: { official: 'República de Costa Rica', common: 'Costa Rica' },
      swe: { official: 'Republiken Costa Rica', common: 'Costa Rica' },
      tur: { official: 'Kosta Rika Cumhuriyeti', common: 'Kosta Rika' },
      urd: { official: 'جمہوریہ کوسٹاریکا', common: 'کوسٹاریکا' },
      zho: { official: '哥斯达黎加共和国', common: '哥斯达黎加' }
    },
    latlng: [10.0, -84.0],
    landlocked: false,
    borders: ['NIC', 'PAN'],
    area: 51100.0,
    demonyms: {
      eng: { f: 'Costa Rican', m: 'Costa Rican' },
      fra: { f: 'Costaricaine', m: 'Costaricain' }
    },
    flag: '\uD83C\uDDE8\uD83C\uDDF7',
    maps: {
      googleMaps: 'https://goo.gl/maps/RFiwytjvNrpfKN7k6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/287667'
    },
    population: 5094114,
    gini: { 2019: 48.2 },
    fifa: 'CRC',
    car: { signs: ['CR'], side: 'right' },
    timezones: ['UTC-06:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/cr.png',
      svg: 'https://flagcdn.com/cr.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/cr.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/cr.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [9.93, -84.09] },
    postalCode: { format: '####', regex: '^(\\d{4})$' }
  },
  {
    name: {
      common: 'Suriname',
      official: 'Republic of Suriname',
      nativeName: {
        nld: { official: 'Republiek Suriname', common: 'Suriname' }
      }
    },
    tld: ['.sr'],
    cca2: 'SR',
    ccn3: '740',
    cca3: 'SUR',
    cioc: 'SUR',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { SRD: { name: 'Surinamese dollar', symbol: '$' } },
    idd: { root: '+5', suffixes: ['97'] },
    capital: ['Paramaribo'],
    altSpellings: [
      'SR',
      'Sarnam',
      'Sranangron',
      'Republic of Suriname',
      'Republiek Suriname'
    ],
    region: 'Americas',
    subregion: 'South America',
    languages: { nld: 'Dutch' },
    translations: {
      ara: { official: 'جمهورية سورينام', common: 'سورينام' },
      bre: { official: 'Republik Surinam', common: 'Surinam' },
      ces: { official: 'Republika Surinam', common: 'Surinam' },
      cym: { official: 'Republic of Suriname', common: 'Suriname' },
      deu: { official: 'Republik Suriname', common: 'Suriname' },
      est: { official: 'Suriname Vabariik', common: 'Suriname' },
      fin: { official: 'Surinamen tasavalta', common: 'Suriname' },
      fra: { official: 'République du Suriname', common: 'Surinam' },
      hrv: { official: 'Republika Surinam', common: 'Surinam' },
      hun: { official: 'Suriname Köztársaság', common: 'Suriname' },
      ita: { official: 'Repubblica del Suriname', common: 'Suriname' },
      jpn: { official: 'スリナム共和国', common: 'スリナム' },
      kor: { official: '수리남 공화국', common: '수리남' },
      nld: { official: 'Republiek Suriname', common: 'Suriname' },
      per: { official: 'جمهوری سورینام', common: 'سورینام' },
      pol: { official: 'Republika Surinamu', common: 'Surinam' },
      por: { official: 'República do Suriname', common: 'Suriname' },
      rus: { official: 'Республика Суринам', common: 'Суринам' },
      slk: { official: 'Surinamská republika', common: 'Surinam' },
      spa: { official: 'República de Suriname', common: 'Surinam' },
      swe: { official: 'Republiken Surinam', common: 'Surinam' },
      tur: { official: 'Surinam Cumhuriyeti', common: 'Surinam' },
      urd: { official: 'جمہوریہ سرینام', common: 'سرینام' },
      zho: { official: '苏里南共和国', common: '苏里南' }
    },
    latlng: [4.0, -56.0],
    landlocked: false,
    borders: ['BRA', 'GUF', 'GUY'],
    area: 163820.0,
    demonyms: {
      eng: { f: 'Surinamer', m: 'Surinamer' },
      fra: { f: 'Surinamaise', m: 'Surinamais' }
    },
    flag: '\uD83C\uDDF8\uD83C\uDDF7',
    maps: {
      googleMaps: 'https://goo.gl/maps/iy7TuQLSi4qgoBoG7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/287082'
    },
    population: 586634,
    gini: { 1999: 57.9 },
    fifa: 'SUR',
    car: { signs: ['SME'], side: 'left' },
    timezones: ['UTC-03:00'],
    continents: ['South America'],
    flags: {
      png: 'https://flagcdn.com/w320/sr.png',
      svg: 'https://flagcdn.com/sr.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/sr.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/sr.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [5.83, -55.17] }
  },
  {
    name: {
      common: 'Anguilla',
      official: 'Anguilla',
      nativeName: { eng: { official: 'Anguilla', common: 'Anguilla' } }
    },
    tld: ['.ai'],
    cca2: 'AI',
    ccn3: '660',
    cca3: 'AIA',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { XCD: { name: 'Eastern Caribbean dollar', symbol: '$' } },
    idd: { root: '+1', suffixes: ['264'] },
    capital: ['The Valley'],
    altSpellings: ['AI'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'أنغويلا', common: 'أنغويلا' },
      bre: { official: 'Anguilla', common: 'Anguilla' },
      ces: { official: 'Anguilla', common: 'Anguilla' },
      cym: { official: 'Anguilla', common: 'Anguilla' },
      deu: { official: 'Anguilla', common: 'Anguilla' },
      est: { official: 'Anguilla', common: 'Anguilla' },
      fin: { official: 'Anguilla', common: 'Anguilla' },
      fra: { official: 'Anguilla', common: 'Anguilla' },
      hrv: { official: 'Anguilla', common: 'Angvila' },
      hun: { official: 'Anguilla', common: 'Anguilla' },
      ita: { official: 'Anguilla', common: 'Anguilla' },
      jpn: { official: 'アングィラ', common: 'アンギラ' },
      kor: { official: '앵귈라', common: '앵귈라' },
      nld: { official: 'Anguilla', common: 'Anguilla' },
      per: { official: 'آنگویلا', common: 'آنگویلا' },
      pol: { official: 'Anguilla', common: 'Anguilla' },
      por: { official: 'Anguilla', common: 'Anguilla' },
      rus: { official: 'Ангилья', common: 'Ангилья' },
      slk: { official: 'Anguilla', common: 'Anguilla' },
      spa: { official: 'Anguila', common: 'Anguilla' },
      swe: { official: 'Anguilla', common: 'Anguilla' },
      tur: { official: 'Anguilla', common: 'Anguilla' },
      urd: { official: 'اینگویلا', common: 'اینگویلا' },
      zho: { official: '安圭拉', common: '安圭拉' }
    },
    latlng: [18.25, -63.16666666],
    landlocked: false,
    area: 91.0,
    demonyms: {
      eng: { f: 'Anguillian', m: 'Anguillian' },
      fra: { f: 'Anguillane', m: 'Anguillan' }
    },
    flag: '\uD83C\uDDE6\uD83C\uDDEE',
    maps: {
      googleMaps: 'https://goo.gl/maps/3KgLnEyN7amdno2p9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/2177161'
    },
    population: 13452,
    fifa: 'AIA',
    car: { signs: ['GB'], side: 'left' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/ai.png',
      svg: 'https://flagcdn.com/ai.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ai.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ai.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [18.22, -63.05] }
  },
  {
    name: {
      common: 'Brazil',
      official: 'Federative Republic of Brazil',
      nativeName: {
        por: { official: 'República Federativa do Brasil', common: 'Brasil' }
      }
    },
    tld: ['.br'],
    cca2: 'BR',
    ccn3: '076',
    cca3: 'BRA',
    cioc: 'BRA',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { BRL: { name: 'Brazilian real', symbol: 'R$' } },
    idd: { root: '+5', suffixes: ['5'] },
    capital: ['Brasília'],
    altSpellings: [
      'BR',
      'Brasil',
      'Federative Republic of Brazil',
      'República Federativa do Brasil'
    ],
    region: 'Americas',
    subregion: 'South America',
    languages: { por: 'Portuguese' },
    translations: {
      ara: { official: 'جمهورية البرازيل الاتحادية', common: 'البرازيل' },
      bre: { official: 'Republik Kevreel Brazil', common: 'Brazil' },
      ces: { official: 'Brazilská federativní republika', common: 'Brazílie' },
      cym: { official: 'Gweriniaeth Ffederal Brasil', common: 'Brasil' },
      deu: { official: 'Föderative Republik Brasilien', common: 'Brasilien' },
      est: { official: 'Brasiilia Liitvabariik', common: 'Brasiilia' },
      fin: { official: 'Brasilian liittotasavalta', common: 'Brasilia' },
      fra: { official: 'République fédérative du Brésil', common: 'Brésil' },
      hrv: { official: 'Savezne Republike Brazil', common: 'Brazil' },
      hun: { official: 'Brazil Szövetségi Köztársaság', common: 'Brazília' },
      ita: { official: 'Repubblica federativa del Brasile', common: 'Brasile' },
      jpn: { official: 'ブラジル連邦共和国', common: 'ブラジル' },
      kor: { official: '브라질 연방 공화국', common: '브라질' },
      nld: { official: 'Federale Republiek Brazilië', common: 'Brazilië' },
      per: { official: 'جمهوری فدراتیو برزیل', common: 'برزیل' },
      pol: { official: 'Federacyjna Republika Brazylii', common: 'Brazylia' },
      por: { official: 'República Federativa do Brasil', common: 'Brasil' },
      rus: { official: 'Федеративная Республика Бразилия', common: 'Бразилия' },
      slk: { official: 'Brazílska federatívna republika', common: 'Brazília' },
      spa: { official: 'República Federativa del Brasil', common: 'Brasil' },
      swe: { official: 'Förbundsrepubliken Brasilien', common: 'Brasilien' },
      tur: { official: 'Brezilya Federal Cumhuriyeti', common: 'Brezilya' },
      urd: { official: 'وفاقی جمہوریہ برازیل', common: 'برازیل' },
      zho: { official: '巴西联邦共和国', common: '巴西' }
    },
    latlng: [-10.0, -55.0],
    landlocked: false,
    borders: [
      'ARG',
      'BOL',
      'COL',
      'GUF',
      'GUY',
      'PRY',
      'PER',
      'SUR',
      'URY',
      'VEN'
    ],
    area: 8515767.0,
    demonyms: {
      eng: { f: 'Brazilian', m: 'Brazilian' },
      fra: { f: 'Brésilienne', m: 'Brésilien' }
    },
    flag: '\uD83C\uDDE7\uD83C\uDDF7',
    maps: {
      googleMaps: 'https://goo.gl/maps/waCKk21HeeqFzkNC9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/59470'
    },
    population: 212559409,
    gini: { 2019: 53.4 },
    fifa: 'BRA',
    car: { signs: ['BR'], side: 'right' },
    timezones: ['UTC-05:00', 'UTC-04:00', 'UTC-03:00', 'UTC-02:00'],
    continents: ['South America'],
    flags: {
      png: 'https://flagcdn.com/w320/br.png',
      svg: 'https://flagcdn.com/br.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/br.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/br.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-15.79, -47.88] },
    postalCode: { format: '#####-###', regex: '^(\\d{8})$' }
  },
  {
    name: {
      common: 'Argentina',
      official: 'Argentine Republic',
      nativeName: {
        grn: { official: 'Argentine Republic', common: 'Argentina' },
        spa: { official: 'República Argentina', common: 'Argentina' }
      }
    },
    tld: ['.ar'],
    cca2: 'AR',
    ccn3: '032',
    cca3: 'ARG',
    cioc: 'ARG',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { ARS: { name: 'Argentine peso', symbol: '$' } },
    idd: { root: '+5', suffixes: ['4'] },
    capital: ['Buenos Aires'],
    altSpellings: ['AR', 'Argentine Republic', 'República Argentina'],
    region: 'Americas',
    subregion: 'South America',
    languages: { grn: 'Guaraní', spa: 'Spanish' },
    translations: {
      ara: { official: 'جمهورية الأرجنتين', common: 'الأرجنتين' },
      bre: { official: "Republik Arc'hantina", common: "Arc'hantina" },
      ces: { official: 'Argentinská republika', common: 'Argentina' },
      cym: { official: 'Gweriniaeth yr Ariannin', common: 'Ariannin' },
      deu: { official: 'Argentinische Republik', common: 'Argentinien' },
      est: { official: 'Argentina Vabariik', common: 'Argentina' },
      fin: { official: 'Argentiinan tasavalta', common: 'Argentiina' },
      fra: { official: 'République argentine', common: 'Argentine' },
      hrv: { official: 'Argentinski Republika', common: 'Argentina' },
      hun: { official: 'Argentin Köztársaság', common: 'Argentína' },
      ita: { official: 'Repubblica Argentina', common: 'Argentina' },
      jpn: { official: 'アルゼンチン共和国', common: 'アルゼンチン' },
      kor: { official: '아르헨티나 공화국', common: '아르헨티나' },
      nld: { official: 'Argentijnse Republiek', common: 'Argentinië' },
      per: { official: 'جمهوری آرژانتین', common: 'آرژانتین' },
      pol: { official: 'Republika Argentyńska', common: 'Argentyna' },
      por: { official: 'República Argentina', common: 'Argentina' },
      rus: { official: 'Аргентинская Республика', common: 'Аргентина' },
      slk: { official: 'Argentínska republika', common: 'Argentína' },
      spa: { official: 'República Argentina', common: 'Argentina' },
      swe: { official: 'Republiken Argentina', common: 'Argentina' },
      tur: { official: 'Arjantin Cumhuriyeti', common: 'Arjantin' },
      urd: { official: 'جمہوریہ ارجنٹائن', common: 'ارجنٹائن' },
      zho: { official: '阿根廷共和国', common: '阿根廷' }
    },
    latlng: [-34.0, -64.0],
    landlocked: false,
    borders: ['BOL', 'BRA', 'CHL', 'PRY', 'URY'],
    area: 2780400.0,
    demonyms: {
      eng: { f: 'Argentine', m: 'Argentine' },
      fra: { f: 'Argentine', m: 'Argentin' }
    },
    flag: '\uD83C\uDDE6\uD83C\uDDF7',
    maps: {
      googleMaps: 'https://goo.gl/maps/Z9DXNxhf2o93kvyc6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/286393'
    },
    population: 45376763,
    gini: { 2019: 42.9 },
    fifa: 'ARG',
    car: { signs: ['RA'], side: 'right' },
    timezones: ['UTC-03:00'],
    continents: ['South America'],
    flags: {
      png: 'https://flagcdn.com/w320/ar.png',
      svg: 'https://flagcdn.com/ar.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ar.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ar.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-34.58, -58.67] },
    postalCode: { format: '@####@@@', regex: '^([A-Z]\\d{4}[A-Z]{3})$' }
  },
  {
    name: {
      common: 'Chile',
      official: 'Republic of Chile',
      nativeName: { spa: { official: 'República de Chile', common: 'Chile' } }
    },
    tld: ['.cl'],
    cca2: 'CL',
    ccn3: '152',
    cca3: 'CHL',
    cioc: 'CHI',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { CLP: { name: 'Chilean peso', symbol: '$' } },
    idd: { root: '+5', suffixes: ['6'] },
    capital: ['Santiago'],
    altSpellings: ['CL', 'Republic of Chile', 'República de Chile'],
    region: 'Americas',
    subregion: 'South America',
    languages: { spa: 'Spanish' },
    translations: {
      ara: { official: 'جمهورية تشيلي', common: 'تشيلي' },
      bre: { official: 'Republik Chile', common: 'Chile' },
      ces: { official: 'Chilská republika', common: 'Chile' },
      cym: { official: 'Gweriniaeth Chile', common: 'Chile' },
      deu: { official: 'Republik Chile', common: 'Chile' },
      est: { official: 'Tšiili Vabariik', common: 'Tšiili' },
      fin: { official: 'Chilen tasavalta', common: 'Chile' },
      fra: { official: 'République du Chili', common: 'Chili' },
      hrv: { official: 'Republika Čile', common: 'Čile' },
      hun: { official: 'Chilei Köztársaság', common: 'Chile' },
      ita: { official: 'Repubblica del Cile', common: 'Cile' },
      jpn: { official: 'チリ共和国', common: 'チリ' },
      kor: { official: '칠레 공화국', common: '칠레' },
      nld: { official: 'Republiek Chili', common: 'Chili' },
      per: { official: 'جمهوری شیلی', common: 'شیلی' },
      pol: { official: 'Republika Chile', common: 'Chile' },
      por: { official: 'República do Chile', common: 'Chile' },
      rus: { official: 'Республика Чили', common: 'Чили' },
      slk: { official: 'Čílska republika', common: 'Čile' },
      spa: { official: 'República de Chile', common: 'Chile' },
      swe: { official: 'Republiken Chile', common: 'Chile' },
      tur: { official: 'Şili Cumhuriyeti', common: 'Şili' },
      urd: { official: 'جمہوریہ چلی', common: 'چلی' },
      zho: { official: '智利共和国', common: '智利' }
    },
    latlng: [-30.0, -71.0],
    landlocked: false,
    borders: ['ARG', 'BOL', 'PER'],
    area: 756102.0,
    demonyms: {
      eng: { f: 'Chilean', m: 'Chilean' },
      fra: { f: 'Chilienne', m: 'Chilien' }
    },
    flag: '\uD83C\uDDE8\uD83C\uDDF1',
    maps: {
      googleMaps: 'https://goo.gl/maps/XboxyNHh2fAjCPNn9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/167454'
    },
    population: 19116209,
    gini: { 2017: 44.4 },
    fifa: 'CHI',
    car: { signs: ['RCH'], side: 'right' },
    timezones: ['UTC-06:00', 'UTC-04:00'],
    continents: ['South America'],
    flags: {
      png: 'https://flagcdn.com/w320/cl.png',
      svg: 'https://flagcdn.com/cl.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/cl.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/cl.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-33.45, -70.67] },
    postalCode: { format: '#######', regex: '^(\\d{7})$' }
  },
  {
    name: {
      common: 'Cayman Islands',
      official: 'Cayman Islands',
      nativeName: {
        eng: { official: 'Cayman Islands', common: 'Cayman Islands' }
      }
    },
    tld: ['.ky'],
    cca2: 'KY',
    ccn3: '136',
    cca3: 'CYM',
    cioc: 'CAY',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { KYD: { name: 'Cayman Islands dollar', symbol: '$' } },
    idd: { root: '+1', suffixes: ['345'] },
    capital: ['George Town'],
    altSpellings: ['KY'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'جزر كايمان', common: 'جزر كايمان' },
      bre: { official: 'Inizi Cayman', common: 'Inizi Cayman' },
      ces: { official: 'Kajmanské ostrovy', common: 'Kajmanské ostrovy' },
      cym: { official: 'Ynysoedd Cayman', common: 'Ynysoedd Cayman' },
      deu: { official: 'Cayman-Inseln', common: 'Kaimaninseln' },
      est: { official: 'Kaimanisaared', common: 'Kaimanisaared' },
      fin: { official: 'Caymansaaret', common: 'Caymansaaret' },
      fra: { official: 'Îles Caïmans', common: 'Îles Caïmans' },
      hrv: { official: 'Kajmanski otoci', common: 'Kajmanski otoci' },
      hun: { official: 'Kajmán-szigetek', common: 'Kajmán-szigetek' },
      ita: { official: 'Isole Cayman', common: 'Isole Cayman' },
      jpn: { official: 'ケイマン諸島', common: 'ケイマン諸島' },
      kor: { official: '케이맨 제도', common: '케이맨 제도' },
      nld: { official: 'Caymaneilanden', common: 'Caymaneilanden' },
      per: { official: 'جزایر کیمن', common: 'جزایر کیمن' },
      pol: { official: 'Kajmany', common: 'Kajmany' },
      por: { official: 'Ilhas Cayman', common: 'Ilhas Caimão' },
      rus: { official: 'Каймановы острова', common: 'Каймановы острова' },
      slk: { official: 'Kajmanie ostrovy', common: 'Kajmanie ostrovy' },
      spa: { official: 'Islas Caimán', common: 'Islas Caimán' },
      swe: { official: 'Caymanöarna', common: 'Caymanöarna' },
      tur: { official: 'Cayman Adaları', common: 'Cayman Adaları' },
      urd: { official: 'جزائر کیمین', common: 'جزائر کیمین' },
      zho: { official: '开曼群岛', common: '开曼群岛' }
    },
    latlng: [19.5, -80.5],
    landlocked: false,
    area: 264.0,
    demonyms: {
      eng: { f: 'Caymanian', m: 'Caymanian' },
      fra: { f: 'Caïmanienne', m: 'Caïmanien' }
    },
    flag: '\uD83C\uDDF0\uD83C\uDDFE',
    maps: {
      googleMaps: 'https://goo.gl/maps/P3ZVXX3LH63t91hL8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/7269765'
    },
    population: 65720,
    fifa: 'CAY',
    car: { signs: ['GB'], side: 'left' },
    timezones: ['UTC-05:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/ky.png',
      svg: 'https://flagcdn.com/ky.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ky.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ky.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [19.3, -81.38] }
  },
  {
    name: {
      common: 'United States',
      official: 'United States of America',
      nativeName: {
        eng: { official: 'United States of America', common: 'United States' }
      }
    },
    tld: ['.us'],
    cca2: 'US',
    ccn3: '840',
    cca3: 'USA',
    cioc: 'USA',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { USD: { name: 'United States dollar', symbol: '$' } },
    idd: {
      root: '+1',
      suffixes: [
        '201',
        '202',
        '203',
        '205',
        '206',
        '207',
        '208',
        '209',
        '210',
        '212',
        '213',
        '214',
        '215',
        '216',
        '217',
        '218',
        '219',
        '220',
        '224',
        '225',
        '227',
        '228',
        '229',
        '231',
        '234',
        '239',
        '240',
        '248',
        '251',
        '252',
        '253',
        '254',
        '256',
        '260',
        '262',
        '267',
        '269',
        '270',
        '272',
        '274',
        '276',
        '281',
        '283',
        '301',
        '302',
        '303',
        '304',
        '305',
        '307',
        '308',
        '309',
        '310',
        '312',
        '313',
        '314',
        '315',
        '316',
        '317',
        '318',
        '319',
        '320',
        '321',
        '323',
        '325',
        '327',
        '330',
        '331',
        '334',
        '336',
        '337',
        '339',
        '346',
        '347',
        '351',
        '352',
        '360',
        '361',
        '364',
        '380',
        '385',
        '386',
        '401',
        '402',
        '404',
        '405',
        '406',
        '407',
        '408',
        '409',
        '410',
        '412',
        '413',
        '414',
        '415',
        '417',
        '419',
        '423',
        '424',
        '425',
        '430',
        '432',
        '434',
        '435',
        '440',
        '442',
        '443',
        '447',
        '458',
        '463',
        '464',
        '469',
        '470',
        '475',
        '478',
        '479',
        '480',
        '484',
        '501',
        '502',
        '503',
        '504',
        '505',
        '507',
        '508',
        '509',
        '510',
        '512',
        '513',
        '515',
        '516',
        '517',
        '518',
        '520',
        '530',
        '531',
        '534',
        '539',
        '540',
        '541',
        '551',
        '559',
        '561',
        '562',
        '563',
        '564',
        '567',
        '570',
        '571',
        '573',
        '574',
        '575',
        '580',
        '585',
        '586',
        '601',
        '602',
        '603',
        '605',
        '606',
        '607',
        '608',
        '609',
        '610',
        '612',
        '614',
        '615',
        '616',
        '617',
        '618',
        '619',
        '620',
        '623',
        '626',
        '628',
        '629',
        '630',
        '631',
        '636',
        '641',
        '646',
        '650',
        '651',
        '657',
        '660',
        '661',
        '662',
        '667',
        '669',
        '678',
        '681',
        '682',
        '701',
        '702',
        '703',
        '704',
        '706',
        '707',
        '708',
        '712',
        '713',
        '714',
        '715',
        '716',
        '717',
        '718',
        '719',
        '720',
        '724',
        '725',
        '727',
        '730',
        '731',
        '732',
        '734',
        '737',
        '740',
        '743',
        '747',
        '754',
        '757',
        '760',
        '762',
        '763',
        '765',
        '769',
        '770',
        '772',
        '773',
        '774',
        '775',
        '779',
        '781',
        '785',
        '786',
        '801',
        '802',
        '803',
        '804',
        '805',
        '806',
        '808',
        '810',
        '812',
        '813',
        '814',
        '815',
        '816',
        '817',
        '818',
        '828',
        '830',
        '831',
        '832',
        '843',
        '845',
        '847',
        '848',
        '850',
        '854',
        '856',
        '857',
        '858',
        '859',
        '860',
        '862',
        '863',
        '864',
        '865',
        '870',
        '872',
        '878',
        '901',
        '903',
        '904',
        '906',
        '907',
        '908',
        '909',
        '910',
        '912',
        '913',
        '914',
        '915',
        '916',
        '917',
        '918',
        '919',
        '920',
        '925',
        '928',
        '929',
        '930',
        '931',
        '934',
        '936',
        '937',
        '938',
        '940',
        '941',
        '947',
        '949',
        '951',
        '952',
        '954',
        '956',
        '959',
        '970',
        '971',
        '972',
        '973',
        '975',
        '978',
        '979',
        '980',
        '984',
        '985',
        '989'
      ]
    },
    capital: ['Washington, D.C.'],
    altSpellings: ['US', 'USA', 'United States of America'],
    region: 'Americas',
    subregion: 'North America',
    languages: { eng: 'English' },
    translations: {
      ara: {
        official: 'الولايات المتحدة الامريكية',
        common: 'الولايات المتحدة'
      },
      bre: { official: 'Stadoù-Unanet Amerika', common: 'Stadoù-Unanet' },
      ces: { official: 'Spojené státy americké', common: 'Spojené státy' },
      cym: { official: 'United States of America', common: 'United States' },
      deu: {
        official: 'Vereinigte Staaten von Amerika',
        common: 'Vereinigte Staaten'
      },
      est: { official: 'Ameerika Ühendriigid', common: 'Ameerika Ühendriigid' },
      fin: { official: 'Amerikan yhdysvallat', common: 'Yhdysvallat' },
      fra: { official: "Les états-unis d'Amérique", common: 'États-Unis' },
      hrv: {
        official: 'Sjedinjene Države Amerike',
        common: 'Sjedinjene Američke Države'
      },
      hun: {
        official: 'Amerikai Egyesült Államok',
        common: 'Amerikai Egyesült Államok'
      },
      ita: {
        official: "Stati Uniti d'America",
        common: "Stati Uniti d'America"
      },
      jpn: { official: 'アメリカ合衆国', common: 'アメリカ合衆国' },
      kor: { official: '아메리카 합중국', common: '미국' },
      nld: {
        official: 'Verenigde Staten van Amerika',
        common: 'Verenigde Staten'
      },
      per: { official: 'ایالات متحده آمریکا', common: 'ایالات متحده آمریکا' },
      pol: {
        official: 'Stany Zjednoczone Ameryki',
        common: 'Stany Zjednoczone'
      },
      por: { official: 'Estados Unidos da América', common: 'Estados Unidos' },
      rus: {
        official: 'Соединенные Штаты Америки',
        common: 'Соединённые Штаты Америки'
      },
      slk: {
        official: 'Spojené štáty Americké',
        common: 'Spojené štáty americké'
      },
      spa: { official: 'Estados Unidos de América', common: 'Estados Unidos' },
      swe: { official: 'Amerikas förenta stater', common: 'USA' },
      tur: {
        official: 'Amerika Birleşik Devletleri',
        common: 'Amerika Birleşik Devletleri'
      },
      urd: { official: 'ریاستہائے متحدہ امریکا', common: 'ریاستہائے متحدہ' },
      zho: { official: '美利坚合众国', common: '美国' }
    },
    latlng: [38.0, -97.0],
    landlocked: false,
    borders: ['CAN', 'MEX'],
    area: 9372610.0,
    demonyms: {
      eng: { f: 'American', m: 'American' },
      fra: { f: 'Américaine', m: 'Américain' }
    },
    flag: '\uD83C\uDDFA\uD83C\uDDF8',
    maps: {
      googleMaps: 'https://goo.gl/maps/e8M246zY4BSjkjAv6',
      openStreetMaps:
        'https://www.openstreetmap.org/relation/148838#map=2/20.6/-85.8'
    },
    population: 329484123,
    gini: { 2018: 41.4 },
    fifa: 'USA',
    car: { signs: ['USA'], side: 'right' },
    timezones: [
      'UTC-12:00',
      'UTC-11:00',
      'UTC-10:00',
      'UTC-09:00',
      'UTC-08:00',
      'UTC-07:00',
      'UTC-06:00',
      'UTC-05:00',
      'UTC-04:00',
      'UTC+10:00',
      'UTC+12:00'
    ],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/us.png',
      svg: 'https://flagcdn.com/us.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/us.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/us.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [38.89, -77.05] },
    postalCode: { format: '#####-####', regex: '^\\d{5}(-\\d{4})?$' }
  },
  {
    name: {
      common: 'Caribbean Netherlands',
      official: 'Bonaire, Sint Eustatius and Saba',
      nativeName: {
        nld: {
          official: 'Bonaire, Sint Eustatius en Saba',
          common: 'Caribisch Nederland'
        },
        pap: {
          official: 'Boneiru, Sint Eustatius y Saba',
          common: 'Boneiru, Sint Eustatius y Saba'
        }
      }
    },
    tld: ['.bq', '.nl'],
    cca2: 'BQ',
    ccn3: '535',
    cca3: 'BES',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { USD: { name: 'United States dollar', symbol: '$' } },
    idd: { root: '+5', suffixes: ['99'] },
    capital: ['Kralendijk'],
    altSpellings: ['BES islands'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English', nld: 'Dutch', pap: 'Papiamento' },
    translations: {
      ara: {
        official: 'بونير وسينت أوستاتيوس وسابا',
        common: 'الجزر الكاريبية الهولندية'
      },
      bre: {
        official: 'Bonaire, Sint Eustatius ha Saba',
        common: 'Bonaire, Sint Eustatius ha Saba'
      },
      ces: { official: 'Karibské Nizozemsko', common: 'Karibské Nizozemsko' },
      cym: {
        official: 'Bonaire, Sint Eustatius and Saba',
        common: 'Caribbean Netherlands'
      },
      deu: {
        official: 'Bonaire, Sint Eustatius und Saba',
        common: 'Karibische Niederlande'
      },
      est: {
        official: 'Bonaire, Sint Eustatius ja Saba',
        common: 'Bonaire, Sint Eustatius ja Saba'
      },
      fin: {
        official: 'Bonaire, Sint Eustatius ja Saba',
        common: 'Bonaire, Sint Eustatius ja Saba'
      },
      fra: {
        official: 'Bonaire, Saint-Eustache et Saba',
        common: 'Pays-Bas caribéens'
      },
      hrv: {
        official: 'Bonaire, Sint Eustatius i Saba',
        common: 'Bonaire, Sint Eustatius i Saba'
      },
      hun: { official: 'Bonaire', common: 'Bonaire' },
      ita: {
        official: 'Bonaire, Sint Eustatius e Saba',
        common: 'Paesi Bassi caraibici'
      },
      jpn: {
        official: 'ボネール、シント・ユースタティウスおよびサバ',
        common: 'ボネール、シント・ユースタティウスおよびサバ'
      },
      kor: {
        official: '보네르, 신트외스타티위스, 사바',
        common: '카리브 네덜란드'
      },
      nld: {
        official: 'Bonaire, Sint Eustatius en Saba',
        common: 'Caribisch Nederland'
      },
      per: { official: 'جزایر کارائیب هلند', common: 'جزایر کارائیب هلند' },
      pol: {
        official: 'Bonaire, Sint Eustatius i Saba',
        common: 'Antyle Holenderskie'
      },
      por: {
        official: 'Bonaire, Saba e Santo Eustáquio',
        common: 'Países Baixos Caribenhos'
      },
      rus: {
        official: 'Бонэйр, Синт-Эстатиус и Саба',
        common: 'Карибские Нидерланды'
      },
      slk: {
        official: 'Bonaire, Sint Eustatius a Saba',
        common: 'Bonaire, Sint Eustatius a Saba'
      },
      spa: {
        official: 'Bonaire, San Eustaquio y Saba',
        common: 'Caribe Neerlandés'
      },
      swe: {
        official: 'Bonaire, Sint Eustatius and Saba',
        common: 'Karibiska Nederländerna'
      },
      tur: { official: 'Karayip Hollandası', common: 'Karayip Hollandası' },
      urd: {
        official: 'بونایر، سینٹ ایوسٹائیس اور سابا',
        common: 'کیریبین نیدرلینڈز'
      },
      zho: { official: '荷蘭加勒比區', common: '荷蘭加勒比區' }
    },
    latlng: [12.18, -68.25],
    landlocked: false,
    area: 328.0,
    demonyms: {
      eng: { f: 'Dutch', m: 'Dutch' },
      fra: { f: 'Néerlandaise', m: 'Néerlandais' }
    },
    flag: '\uD83C\uDDE7\uD83C\uDDF6',
    maps: {
      googleMaps: 'https://goo.gl/maps/4XVes1P6uEDTz77WA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/1216720'
    },
    population: 25987,
    car: { signs: [''], side: 'right' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/bq.png',
      svg: 'https://flagcdn.com/bq.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/bq.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/bq.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [12.14, -68.27] }
  },
  {
    name: {
      common: 'Mexico',
      official: 'United Mexican States',
      nativeName: {
        spa: { official: 'Estados Unidos Mexicanos', common: 'México' }
      }
    },
    tld: ['.mx'],
    cca2: 'MX',
    ccn3: '484',
    cca3: 'MEX',
    cioc: 'MEX',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { MXN: { name: 'Mexican peso', symbol: '$' } },
    idd: { root: '+5', suffixes: ['2'] },
    capital: ['Mexico City'],
    altSpellings: [
      'MX',
      'Mexicanos',
      'United Mexican States',
      'Estados Unidos Mexicanos'
    ],
    region: 'Americas',
    subregion: 'North America',
    languages: { spa: 'Spanish' },
    translations: {
      ara: { official: 'الولايات المتحدة المكسيكية', common: 'المسكيك' },
      bre: { official: "Stadoù-Unanet Mec'hiko", common: "Mec'hiko" },
      ces: { official: 'Spojené státy mexické', common: 'Mexiko' },
      cym: { official: 'United Mexican States', common: 'Mexico' },
      deu: { official: 'Vereinigte Mexikanische Staaten', common: 'Mexiko' },
      est: { official: 'Mehhiko Ühendriigid', common: 'Mehhiko' },
      fin: { official: 'Meksikon yhdysvallat', common: 'Meksiko' },
      fra: { official: 'États-Unis du Mexique', common: 'Mexique' },
      hrv: { official: 'Sjedinjene Meksičke Države', common: 'Meksiko' },
      hun: { official: 'Mexikói Egyesült Államok', common: 'Mexikó' },
      ita: { official: 'Stati Uniti del Messico', common: 'Messico' },
      jpn: { official: 'メキシコ合衆国', common: 'メキシコ' },
      kor: { official: '멕시코 합중국', common: '멕시코' },
      nld: { official: 'Verenigde Mexicaanse Staten', common: 'Mexico' },
      per: { official: 'ایالات متحد مکزیک', common: 'مکزیک' },
      pol: { official: 'Meksykańskie Stany Zjednoczone', common: 'Meksyk' },
      por: { official: 'Estados Unidos Mexicanos', common: 'México' },
      rus: { official: 'Мексиканские Соединённые Штаты', common: 'Мексика' },
      slk: { official: 'Spojené štášy mexické', common: 'Mexiko' },
      spa: { official: 'Estados Unidos Mexicanos', common: 'México' },
      swe: { official: 'Mexikos förenta stater', common: 'Mexiko' },
      tur: { official: 'Birleşik Meksika Devletleri', common: 'Meksika' },
      urd: { official: 'ریاستہائے متحدہ میکسیکو', common: 'میکسیکو' },
      zho: { official: '墨西哥合众国', common: '墨西哥' }
    },
    latlng: [23.0, -102.0],
    landlocked: false,
    borders: ['BLZ', 'GTM', 'USA'],
    area: 1964375.0,
    demonyms: {
      eng: { f: 'Mexican', m: 'Mexican' },
      fra: { f: 'Mexicaine', m: 'Mexicain' }
    },
    flag: '\uD83C\uDDF2\uD83C\uDDFD',
    maps: {
      googleMaps: 'https://goo.gl/maps/s5g7imNPMDEePxzbA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/114686'
    },
    population: 128932753,
    gini: { 2018: 45.4 },
    fifa: 'MEX',
    car: { signs: ['MEX'], side: 'right' },
    timezones: ['UTC-08:00', 'UTC-07:00', 'UTC-06:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/mx.png',
      svg: 'https://flagcdn.com/mx.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/mx.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/mx.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [19.43, -99.13] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Belize',
      official: 'Belize',
      nativeName: {
        bjz: { official: 'Belize', common: 'Belize' },
        eng: { official: 'Belize', common: 'Belize' },
        spa: { official: 'Belice', common: 'Belice' }
      }
    },
    tld: ['.bz'],
    cca2: 'BZ',
    ccn3: '084',
    cca3: 'BLZ',
    cioc: 'BIZ',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { BZD: { name: 'Belize dollar', symbol: '$' } },
    idd: { root: '+5', suffixes: ['01'] },
    capital: ['Belmopan'],
    altSpellings: ['BZ'],
    region: 'Americas',
    subregion: 'Central America',
    languages: { bjz: 'Belizean Creole', eng: 'English', spa: 'Spanish' },
    translations: {
      ara: { official: 'بليز', common: 'بليز' },
      bre: { official: 'Belize', common: 'Belize' },
      ces: { official: 'Belize', common: 'Belize' },
      cym: { official: 'Belîs', common: 'Belîs' },
      deu: { official: 'Belize', common: 'Belize' },
      est: { official: 'Belize', common: 'Belize' },
      fin: { official: 'Belize', common: 'Belize' },
      fra: { official: 'Belize', common: 'Belize' },
      hrv: { official: 'Belize', common: 'Belize' },
      hun: { official: 'Belize', common: 'Belize' },
      ita: { official: 'Belize', common: 'Belize' },
      jpn: { official: 'ベリーズ', common: 'ベリーズ' },
      kor: { official: '벨리즈', common: '벨리즈' },
      nld: { official: 'Belize', common: 'Belize' },
      per: { official: 'بلیز', common: 'بلیز' },
      pol: { official: 'Belize', common: 'Belize' },
      por: { official: 'Belize', common: 'Belize' },
      rus: { official: 'Белиз', common: 'Белиз' },
      slk: { official: 'Belize', common: 'Belize' },
      spa: { official: 'Belice', common: 'Belice' },
      swe: { official: 'Belize', common: 'Belize' },
      tur: { official: 'Belize', common: 'Belize' },
      urd: { official: 'بیلیز', common: 'بیلیز' },
      zho: { official: '伯利兹', common: '伯利兹' }
    },
    latlng: [17.25, -88.75],
    landlocked: false,
    borders: ['GTM', 'MEX'],
    area: 22966.0,
    demonyms: {
      eng: { f: 'Belizean', m: 'Belizean' },
      fra: { f: 'Bélizienne', m: 'Bélizien' }
    },
    flag: '\uD83C\uDDE7\uD83C\uDDFF',
    maps: {
      googleMaps: 'https://goo.gl/maps/jdCccpdLodm1uTmo9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/287827'
    },
    population: 397621,
    gini: { 1999: 53.3 },
    fifa: 'BLZ',
    car: { signs: ['BH'], side: 'right' },
    timezones: ['UTC-06:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/bz.png',
      svg: 'https://flagcdn.com/bz.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/bz.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/bz.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [17.25, -88.77] }
  },
  {
    name: {
      common: 'Dominican Republic',
      official: 'Dominican Republic',
      nativeName: {
        spa: {
          official: 'República Dominicana',
          common: 'República Dominicana'
        }
      }
    },
    tld: ['.do'],
    cca2: 'DO',
    ccn3: '214',
    cca3: 'DOM',
    cioc: 'DOM',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { DOP: { name: 'Dominican peso', symbol: '$' } },
    idd: { root: '+1', suffixes: ['809', '829', '849'] },
    capital: ['Santo Domingo'],
    altSpellings: ['DO'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { spa: 'Spanish' },
    translations: {
      ara: { official: 'جمهورية الدومينيكان', common: 'جمهورية الدومينيكان' },
      bre: { official: 'Republik Dominikan', common: 'Republik Dominikan' },
      ces: {
        official: 'Dominikánská republika',
        common: 'Dominikánská republika'
      },
      cym: { official: 'Gweriniaeth Dominica', common: 'Gweriniaeth Dominica' },
      deu: {
        official: 'Dominikanische Republik',
        common: 'Dominikanische Republik'
      },
      est: { official: 'Dominikaani Vabariik', common: 'Dominikaani Vabariik' },
      fin: {
        official: 'Dominikaaninen tasavalta',
        common: 'Dominikaaninen tasavalta'
      },
      fra: {
        official: 'République Dominicaine',
        common: 'République dominicaine'
      },
      hrv: {
        official: 'Dominikanska Republika',
        common: 'Dominikanska Republika'
      },
      hun: {
        official: 'Dominikai Köztársaság',
        common: 'Dominikai Köztársaság'
      },
      ita: {
        official: 'Repubblica Dominicana',
        common: 'Repubblica Dominicana'
      },
      jpn: { official: 'ドミニカ共和国', common: 'ドミニカ共和国' },
      kor: { official: '도미니카 공화국', common: '도미니카 공화국' },
      nld: {
        official: 'Dominicaanse Republiek',
        common: 'Dominicaanse Republiek'
      },
      per: { official: 'جمهوری دومینیکن', common: 'جمهوری دومینیکن' },
      pol: { official: 'Republika Dominikańska', common: 'Dominikana' },
      por: { official: 'República Dominicana', common: 'República Dominicana' },
      rus: {
        official: 'Доминиканская Республика',
        common: 'Доминиканская Республика'
      },
      slk: {
        official: 'Dominikánska republika',
        common: 'Dominikánska republika'
      },
      spa: { official: 'República Dominicana', common: 'República Dominicana' },
      swe: {
        official: 'Dominikanska republiken',
        common: 'Dominikanska republiken'
      },
      tur: { official: 'Dominik Cumhuriyeti', common: 'Dominik Cumhuriyeti' },
      urd: { official: 'جمہوریہ ڈومینیکن', common: 'ڈومینیکن' },
      zho: { official: '多明尼加共和国', common: '多明尼加' }
    },
    latlng: [19.0, -70.66666666],
    landlocked: false,
    borders: ['HTI'],
    area: 48671.0,
    demonyms: {
      eng: { f: 'Dominican', m: 'Dominican' },
      fra: { f: 'Dominicaine', m: 'Dominicain' }
    },
    flag: '\uD83C\uDDE9\uD83C\uDDF4',
    maps: {
      googleMaps: 'https://goo.gl/maps/soxooTHxEeiAbn3UA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/307828'
    },
    population: 10847904,
    gini: { 2019: 41.9 },
    fifa: 'DOM',
    car: { signs: ['DOM'], side: 'right' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/do.png',
      svg: 'https://flagcdn.com/do.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/do.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/do.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [18.47, -69.9] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Turks and Caicos Islands',
      official: 'Turks and Caicos Islands',
      nativeName: {
        eng: {
          official: 'Turks and Caicos Islands',
          common: 'Turks and Caicos Islands'
        }
      }
    },
    tld: ['.tc'],
    cca2: 'TC',
    ccn3: '796',
    cca3: 'TCA',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { USD: { name: 'United States dollar', symbol: '$' } },
    idd: { root: '+1', suffixes: ['649'] },
    capital: ['Cockburn Town'],
    altSpellings: ['TC'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'جزر توركس وكايكوس', common: 'جزر توركس وكايكوس' },
      bre: {
        official: 'Inizi Turks ha Caicos',
        common: 'Inizi Turks ha Caicos'
      },
      ces: { official: 'Turks a Caicos', common: 'Turks a Caicos' },
      cym: {
        official: 'Turks and Caicos Islands',
        common: 'Turks and Caicos Islands'
      },
      deu: {
        official: 'Turks und Caicos Inseln',
        common: 'Turks-und Caicosinseln'
      },
      est: { official: 'Turksi ja Caicose saared', common: 'Turks ja Caicos' },
      fin: {
        official: 'Turks-ja Caicossaaret',
        common: 'Turks-ja Caicossaaret'
      },
      fra: {
        official: 'Îles Turques et Caïques',
        common: 'Îles Turques-et-Caïques'
      },
      hrv: { official: 'Otoci Turks i Caicos', common: 'Otoci Turks i Caicos' },
      hun: {
        official: 'Turks- és Caicos-szigetek',
        common: 'Turks- és Caicos-szigetek'
      },
      ita: { official: 'Turks e Caicos', common: 'Isole Turks e Caicos' },
      jpn: {
        official: 'タークス·カイコス諸島',
        common: 'タークス・カイコス諸島'
      },
      kor: { official: '터크스 케이커스 제도', common: '터크스 케이커스 제도' },
      nld: {
        official: 'Turks-en Caicoseilanden',
        common: 'Turks-en Caicoseilanden'
      },
      per: { official: 'جزایر تورکس و کایکوس', common: 'جزایر تورکس و کایکوس' },
      pol: { official: 'Turks i Caicos', common: 'Turks i Caicos' },
      por: { official: 'Ilhas Turks e Caicos', common: 'Ilhas Turks e Caicos' },
      rus: { official: 'Теркс и Кайкос острова', common: 'Теркс и Кайкос' },
      slk: { official: 'Ostrovy Turks a Caicos', common: 'Turks a Caicos' },
      spa: {
        official: 'Islas Turcas y Caicos',
        common: 'Islas Turks y Caicos'
      },
      swe: {
        official: 'Turks- och Caicosöarna',
        common: 'Turks- och Caicosöarna'
      },
      tur: {
        official: 'Turks ve Caicos Adaları',
        common: 'Turks ve Caicos Adaları'
      },
      urd: { official: 'جزائر کیکس و ترکیہ', common: 'جزائر کیکس و ترکیہ' },
      zho: { official: '特克斯和凯科斯群岛', common: '特克斯和凯科斯群岛' }
    },
    latlng: [21.75, -71.58333333],
    landlocked: false,
    area: 948.0,
    demonyms: {
      eng: { f: 'Turks and Caicos Islander', m: 'Turks and Caicos Islander' }
    },
    flag: '\uD83C\uDDF9\uD83C\uDDE8',
    maps: {
      googleMaps: 'https://goo.gl/maps/R8VUDQfwZiFtvmyn8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/547479'
    },
    population: 38718,
    fifa: 'TCA',
    car: { signs: ['GB'], side: 'left' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/tc.png',
      svg: 'https://flagcdn.com/tc.svg'
    },
    coatOfArms: {},
    startOfWeek: 'monday',
    capitalInfo: { latlng: [21.46, -71.14] },
    postalCode: { format: 'TKCA 1ZZ', regex: '^(TKCA 1ZZ)$' }
  },
  {
    name: {
      common: 'Saint Kitts and Nevis',
      official: 'Federation of Saint Christopher and Nevis',
      nativeName: {
        eng: {
          official: 'Federation of Saint Christopher and Nevis',
          common: 'Saint Kitts and Nevis'
        }
      }
    },
    tld: ['.kn'],
    cca2: 'KN',
    ccn3: '659',
    cca3: 'KNA',
    cioc: 'SKN',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { XCD: { name: 'Eastern Caribbean dollar', symbol: '$' } },
    idd: { root: '+1', suffixes: ['869'] },
    capital: ['Basseterre'],
    altSpellings: ['KN', 'Federation of Saint Christopher and Nevis'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English' },
    translations: {
      ara: {
        official: 'اتحاد القديس كريستوفر ونيفيس',
        common: 'سانت كيتس ونيفيس'
      },
      bre: {
        official: 'Kevread Saint Kitts ha Nevis',
        common: 'Saint Kitts ha Nevis'
      },
      ces: {
        official: 'Federace Sv. Kryštof a Nevis',
        common: 'Svatý Kryštof a Nevis'
      },
      cym: {
        official: 'Federation of Saint Christopher and Nevis',
        common: 'Saint Kitts and Nevis'
      },
      deu: {
        official: 'Föderation von St. Kitts und Nevis',
        common: 'St. Kitts und Nevis'
      },
      est: {
        official: 'Saint Kittsi ja Nevise Föderatsioon',
        common: 'Saint Kitts ja Nevis'
      },
      fin: {
        official: 'Saint Christopherin ja Nevisin federaatio',
        common: 'Saint Kitts ja Nevis'
      },
      fra: {
        official: 'Fédération de Saint-Christophe-et-Niévès',
        common: 'Saint-Christophe-et-Niévès'
      },
      hrv: {
        official: 'Federacija Sv.Kristofora i Nevisa',
        common: 'Sveti Kristof i Nevis'
      },
      hun: {
        official: 'Saint Christopher és Nevis Államszövetség',
        common: 'Saint Kitts és Nevis'
      },
      ita: {
        official: 'Federazione di Saint Christopher e Nevis',
        common: 'Saint Kitts e Nevis'
      },
      jpn: {
        official: 'セントクリストファーNevis連盟',
        common: 'セントクリストファー・ネイビス'
      },
      kor: { official: '세인트키츠 네비스 연방', common: '세인트키츠 네비스' },
      nld: {
        official: 'Federatie van Saint Kitts en Nevis',
        common: 'Saint Kitts en Nevis'
      },
      per: { official: 'فدراسیون سنت کیتس و نویس', common: 'سنت کیتس و نویس' },
      pol: {
        official: 'Federacja Saint Kitts i Nevis',
        common: 'Saint Kitts i Nevis'
      },
      por: {
        official: 'Federação de São Cristóvão e Nevis',
        common: 'São Cristóvão e Nevis'
      },
      rus: {
        official: 'Федерация Сент-Кристофер и Н е в и с',
        common: 'Сент-Китс и Невис'
      },
      slk: {
        official: 'Feder໡cia Svätého Krištofa a Nevisu',
        common: 'Svätý Krištof a Nevis'
      },
      spa: {
        official: 'Federación de San Cristóbal y Nevis',
        common: 'San Cristóbal y Nieves'
      },
      swe: {
        official: 'Federationen Saint Kitts och Nevis',
        common: 'Saint Kitts och Nevis'
      },
      tur: {
        official: 'Saint Kitts ve Nevis Federasyonu',
        common: 'Saint Kitts ve Nevis'
      },
      urd: { official: 'وفاقِ سینٹ کیٹز و ناویس', common: 'سینٹ کیٹز و ناویس' },
      zho: { official: '圣克里斯托弗和尼维斯联邦', common: '圣基茨和尼维斯' }
    },
    latlng: [17.33333333, -62.75],
    landlocked: false,
    area: 261.0,
    demonyms: {
      eng: { f: 'Kittitian or Nevisian', m: 'Kittitian or Nevisian' },
      fra: { f: 'Kittitienne-et-nevicienne', m: 'Kittitien-et-nevicien' }
    },
    flag: '\uD83C\uDDF0\uD83C\uDDF3',
    maps: {
      googleMaps: 'https://goo.gl/maps/qiaVwcLVTXX3eoTNA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/536899'
    },
    population: 53192,
    fifa: 'SKN',
    car: { signs: ['KN'], side: 'left' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/kn.png',
      svg: 'https://flagcdn.com/kn.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/kn.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/kn.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [17.3, -62.72] }
  },
  {
    name: {
      common: 'Haiti',
      official: 'Republic of Haiti',
      nativeName: {
        fra: { official: "République d'Haïti", common: 'Haïti' },
        hat: { official: 'Repiblik Ayiti', common: 'Ayiti' }
      }
    },
    tld: ['.ht'],
    cca2: 'HT',
    ccn3: '332',
    cca3: 'HTI',
    cioc: 'HAI',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { HTG: { name: 'Haitian gourde', symbol: 'G' } },
    idd: { root: '+5', suffixes: ['09'] },
    capital: ['Port-au-Prince'],
    altSpellings: [
      'HT',
      'Republic of Haiti',
      "République d'Haïti",
      'Repiblik Ayiti'
    ],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { fra: 'French', hat: 'Haitian Creole' },
    translations: {
      ara: { official: 'جمهورية هايتي', common: 'هايتي' },
      bre: { official: 'Republik Haiti', common: 'Haiti' },
      ces: { official: 'Republika Haiti', common: 'Haiti' },
      cym: { official: 'Republic of Haiti', common: 'Haiti' },
      deu: { official: 'Republik Haiti', common: 'Haiti' },
      est: { official: 'Haiti Vabariik', common: 'Haiti' },
      fin: { official: 'Haitin tasavalta', common: 'Haiti' },
      fra: { official: "République d'Haïti", common: 'Haïti' },
      hrv: { official: 'Republika Haiti', common: 'Haiti' },
      hun: { official: 'Haiti Köztársaság', common: 'Haiti' },
      ita: { official: 'Repubblica di Haiti', common: 'Haiti' },
      jpn: { official: 'ハイチ共和国', common: 'ハイチ' },
      kor: { official: '아이티 공화국', common: '아이티' },
      nld: { official: 'Republiek Haïti', common: 'Haïti' },
      per: { official: 'جمهوری هائیتی', common: 'هائیتی' },
      pol: { official: 'Republika Haiti', common: 'Haiti' },
      por: { official: 'República do Haiti', common: 'Haiti' },
      rus: { official: 'Республика Гаити', common: 'Гаити' },
      slk: { official: 'Haitská republika', common: 'Haiti' },
      spa: { official: 'República de Haití', common: 'Haití' },
      swe: { official: 'Republiken Haiti', common: 'Haiti' },
      tur: { official: 'Haiti Cumhuriyeti', common: 'Haiti' },
      urd: { official: 'جمہوریہ ہیٹی', common: 'ہیٹی' },
      zho: { official: '海地共和国', common: '海地' }
    },
    latlng: [19.0, -72.41666666],
    landlocked: false,
    borders: ['DOM'],
    area: 27750.0,
    demonyms: {
      eng: { f: 'Haitian', m: 'Haitian' },
      fra: { f: 'Haïtienne', m: 'Haïtien' }
    },
    flag: '\uD83C\uDDED\uD83C\uDDF9',
    maps: {
      googleMaps: 'https://goo.gl/maps/9o13xtjuUdqFnHbn9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/307829'
    },
    population: 11402533,
    gini: { 2012: 41.1 },
    fifa: 'HAI',
    car: { signs: ['RH'], side: 'right' },
    timezones: ['UTC-05:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/ht.png',
      svg: 'https://flagcdn.com/ht.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ht.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ht.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [18.53, -72.33] },
    postalCode: { format: 'HT####', regex: '^(?:HT)*(\\d{4})$' }
  },
  {
    name: {
      common: 'British Virgin Islands',
      official: 'Virgin Islands',
      nativeName: {
        eng: { official: 'Virgin Islands', common: 'British Virgin Islands' }
      }
    },
    tld: ['.vg'],
    cca2: 'VG',
    ccn3: '092',
    cca3: 'VGB',
    cioc: 'IVB',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { USD: { name: 'United States dollar', symbol: '$' } },
    idd: { root: '+1', suffixes: ['284'] },
    capital: ['Road Town'],
    altSpellings: ['VG', 'Virgin Islands, British'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'جزر العذراء البريطانية', common: 'جزر العذراء' },
      bre: {
        official: "Inizi Gwerc'h Breizhveurat",
        common: "Inizi Gwerc'h Breizhveurat"
      },
      ces: {
        official: 'Britské Panenské ostrovy',
        common: 'Britské Panenské ostrovy'
      },
      cym: { official: 'Virgin Islands', common: 'British Virgin Islands' },
      deu: { official: 'Jungferninseln', common: 'Britische Jungferninseln' },
      est: { official: 'Neitsisaared', common: 'Briti Neitsisaared' },
      fin: { official: 'Brittiläiset Neitsytsaaret', common: 'Neitsytsaaret' },
      fra: { official: 'îles Vierges', common: 'Îles Vierges britanniques' },
      hrv: {
        official: 'Djevičanski Otoci',
        common: 'Britanski Djevičanski Otoci'
      },
      hun: { official: 'Brit Virgin-szigetek', common: 'Brit Virgin-szigetek' },
      ita: { official: 'Isole Vergini', common: 'Isole Vergini Britanniche' },
      jpn: { official: 'バージン諸島', common: 'イギリス領ヴァージン諸島' },
      kor: { official: '영국령 버진아일랜드', common: '영국령 버진아일랜드' },
      nld: { official: 'Maagdeneilanden', common: 'Britse Maagdeneilanden' },
      per: {
        official: 'جزایر ویرجین بریتانیا',
        common: 'جزایر ویرجین بریتانیا'
      },
      pol: {
        official: 'Brytyjskie Wyspy Dziewicze',
        common: 'Brytyjskie Wyspy Dziewicze'
      },
      por: { official: 'Ilhas Virgens', common: 'Ilhas Virgens' },
      rus: {
        official: 'Виргинские острова',
        common: 'Британские Виргинские острова'
      },
      slk: { official: 'Panenské ostrovy', common: 'Panenské ostrovy' },
      spa: {
        official: 'Islas Vírgenes',
        common: 'Islas Vírgenes del Reino Unido'
      },
      swe: {
        official: 'Brittiska Jungfruöarna',
        common: 'Brittiska Jungfruöarna'
      },
      tur: { official: 'Virjin Adaları', common: 'Virjin Adaları' },
      urd: { official: 'برطانوی جزائر ورجن', common: 'برطانوی جزائر ورجن' },
      zho: { official: '英属维尔京群岛', common: '英属维尔京群岛' }
    },
    latlng: [18.431383, -64.62305],
    landlocked: false,
    area: 151.0,
    demonyms: { eng: { f: 'Virgin Islander', m: 'Virgin Islander' } },
    flag: '\uD83C\uDDFB\uD83C\uDDEC',
    maps: {
      googleMaps: 'https://goo.gl/maps/49C9cSesNVAR9DQk8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/285454'
    },
    population: 30237,
    fifa: 'VGB',
    car: { signs: ['BVI'], side: 'left' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/vg.png',
      svg: 'https://flagcdn.com/vg.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/vg.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/vg.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [18.42, -64.62] }
  },
  {
    name: {
      common: 'Dominica',
      official: 'Commonwealth of Dominica',
      nativeName: {
        eng: { official: 'Commonwealth of Dominica', common: 'Dominica' }
      }
    },
    tld: ['.dm'],
    cca2: 'DM',
    ccn3: '212',
    cca3: 'DMA',
    cioc: 'DMA',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { XCD: { name: 'Eastern Caribbean dollar', symbol: '$' } },
    idd: { root: '+1', suffixes: ['767'] },
    capital: ['Roseau'],
    altSpellings: [
      'DM',
      'Dominique',
      'Wai‘tu kubuli',
      'Commonwealth of Dominica'
    ],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'كومونولث دومينيكا', common: 'دومينيكا' },
      bre: { official: 'Kenglad Dominika', common: 'Dominika' },
      ces: { official: 'Dominikánské společenství', common: 'Dominika' },
      cym: { official: 'Cymanwlad Dominica', common: 'Dominica' },
      deu: { official: 'Commonwealth von Dominica', common: 'Dominica' },
      est: { official: 'Dominica Ühendus', common: 'Dominica' },
      fin: { official: 'Dominican liittovaltio', common: 'Dominica' },
      fra: { official: 'Commonwealth de la Dominique', common: 'Dominique' },
      hrv: { official: 'Zajednica Dominika', common: 'Dominika' },
      hun: { official: 'Dominikai Közösség', common: 'Dominikai Közösség' },
      ita: { official: 'Commonwealth di Dominica', common: 'Dominica' },
      jpn: { official: 'ドミニカ国', common: 'ドミニカ国' },
      kor: { official: '도미니카 공화국', common: '도미니카 공화국' },
      nld: { official: 'Gemenebest Dominica', common: 'Dominica' },
      per: { official: 'قلمرو همسود دومینیکا', common: 'دومینیکا' },
      pol: { official: 'Wspólnota Dominiki', common: 'Dominika' },
      por: { official: 'Comunidade da Dominica', common: 'Dominica' },
      rus: { official: 'Содружество Доминики', common: 'Доминика' },
      slk: { official: 'Dominické spoločenstvo', common: 'Dominika' },
      spa: { official: 'Mancomunidad de Dominica', common: 'Dominica' },
      swe: { official: 'Samväldet Dominica', common: 'Dominica' },
      tur: { official: 'Dominika Topluluğu', common: 'Dominika' },
      urd: { official: 'دولتِ مشترکہ ڈومینیکا', common: 'ڈومینیکا' },
      zho: { official: '多米尼加共和国', common: '多米尼加' }
    },
    latlng: [15.41666666, -61.33333333],
    landlocked: false,
    area: 751.0,
    demonyms: {
      eng: { f: 'Dominican', m: 'Dominican' },
      fra: { f: 'Dominiquaise', m: 'Dominiquais' }
    },
    flag: '\uD83C\uDDE9\uD83C\uDDF2',
    maps: {
      googleMaps: 'https://goo.gl/maps/HSKdHYpFC8oHHuyV7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/307823'
    },
    population: 71991,
    fifa: 'DMA',
    car: { signs: ['WD'], side: 'left' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/dm.png',
      svg: 'https://flagcdn.com/dm.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/dm.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/dm.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [15.3, -61.4] }
  },
  {
    name: {
      common: 'Colombia',
      official: 'Republic of Colombia',
      nativeName: {
        spa: { official: 'República de Colombia', common: 'Colombia' }
      }
    },
    tld: ['.co'],
    cca2: 'CO',
    ccn3: '170',
    cca3: 'COL',
    cioc: 'COL',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { COP: { name: 'Colombian peso', symbol: '$' } },
    idd: { root: '+5', suffixes: ['7'] },
    capital: ['Bogotá'],
    altSpellings: ['CO', 'Republic of Colombia', 'República de Colombia'],
    region: 'Americas',
    subregion: 'South America',
    languages: { spa: 'Spanish' },
    translations: {
      ara: { official: 'جمهورية كولومبيا', common: 'كولومبيا' },
      bre: { official: 'Republik Kolombia', common: 'Kolombia' },
      ces: { official: 'Kolumbijská republika', common: 'Kolumbie' },
      cym: { official: 'Gweriniaeth Colombia', common: 'Colombia' },
      deu: { official: 'Republik Kolumbien', common: 'Kolumbien' },
      est: { official: 'Colombia Vabariik', common: 'Colombia' },
      fin: { official: 'Kolumbian tasavalta', common: 'Kolumbia' },
      fra: { official: 'République de Colombie', common: 'Colombie' },
      hrv: { official: 'Republika Kolumbija', common: 'Kolumbija' },
      hun: { official: 'Kolumbiai Köztársaság', common: 'Kolumbia' },
      ita: { official: 'Repubblica di Colombia', common: 'Colombia' },
      jpn: { official: 'コロンビア共和国', common: 'コロンビア' },
      kor: { official: '콜롬비아 공화국', common: '콜롬비아' },
      nld: { official: 'Republiek Colombia', common: 'Colombia' },
      per: { official: 'جمهوری کلمبیا', common: 'کلمبیا' },
      pol: { official: 'Republika Kolumbii', common: 'Kolumbia' },
      por: { official: 'República da Colômbia', common: 'Colômbia' },
      rus: { official: 'Республика Колумбия', common: 'Колумбия' },
      slk: { official: 'Kolumbijská republika', common: 'Kolumbia' },
      spa: { official: 'República de Colombia', common: 'Colombia' },
      swe: { official: 'Republiken Colombia', common: 'Colombia' },
      tur: { official: 'Kolombiya Cumhuriyeti', common: 'Kolombiya' },
      urd: { official: 'جمہوریہ کولمبیا', common: 'کولمبیا' },
      zho: { official: '哥伦比亚共和国', common: '哥伦比亚' }
    },
    latlng: [4.0, -72.0],
    landlocked: false,
    borders: ['BRA', 'ECU', 'PAN', 'PER', 'VEN'],
    area: 1141748.0,
    demonyms: {
      eng: { f: 'Colombian', m: 'Colombian' },
      fra: { f: 'Colombienne', m: 'Colombien' }
    },
    flag: '\uD83C\uDDE8\uD83C\uDDF4',
    maps: {
      googleMaps: 'https://goo.gl/maps/RdwTG8e7gPwS62oR6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/120027'
    },
    population: 50882884,
    gini: { 2019: 51.3 },
    fifa: 'COL',
    car: { signs: ['CO'], side: 'right' },
    timezones: ['UTC-05:00'],
    continents: ['South America'],
    flags: {
      png: 'https://flagcdn.com/w320/co.png',
      svg: 'https://flagcdn.com/co.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/co.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/co.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [4.71, -74.07] }
  },
  {
    name: {
      common: 'Canada',
      official: 'Canada',
      nativeName: {
        eng: { official: 'Canada', common: 'Canada' },
        fra: { official: 'Canada', common: 'Canada' }
      }
    },
    tld: ['.ca'],
    cca2: 'CA',
    ccn3: '124',
    cca3: 'CAN',
    cioc: 'CAN',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { CAD: { name: 'Canadian dollar', symbol: '$' } },
    idd: { root: '+1', suffixes: [''] },
    capital: ['Ottawa'],
    altSpellings: ['CA'],
    region: 'Americas',
    subregion: 'North America',
    languages: { eng: 'English', fra: 'French' },
    translations: {
      ara: { official: 'كندا', common: 'كندا' },
      bre: { official: 'Kanada', common: 'Kanada' },
      ces: { official: 'Kanada', common: 'Kanada' },
      cym: { official: 'Canada', common: 'Canada' },
      deu: { official: 'Kanada', common: 'Kanada' },
      est: { official: 'Kanada', common: 'Kanada' },
      fin: { official: 'Kanada', common: 'Kanada' },
      fra: { official: 'Canada', common: 'Canada' },
      hrv: { official: 'Kanada', common: 'Kanada' },
      hun: { official: 'Kanada', common: 'Kanada' },
      ita: { official: 'Canada', common: 'Canada' },
      jpn: { official: 'カナダ', common: 'カナダ' },
      kor: { official: '캐나다', common: '캐나다' },
      nld: { official: 'Canada', common: 'Canada' },
      per: { official: 'کانادا', common: 'کانادا' },
      pol: { official: 'Kanada', common: 'Kanada' },
      por: { official: 'Canadá', common: 'Canadá' },
      rus: { official: 'Канада', common: 'Канада' },
      slk: { official: 'Kanada', common: 'Kanada' },
      spa: { official: 'Canadá', common: 'Canadá' },
      swe: { official: 'Kanada', common: 'Kanada' },
      tur: { official: 'Kanada', common: 'Kanada' },
      urd: { official: 'کینیڈا', common: 'کینیڈا' },
      zho: { official: '加拿大', common: '加拿大' }
    },
    latlng: [60.0, -95.0],
    landlocked: false,
    borders: ['USA'],
    area: 9984670.0,
    demonyms: {
      eng: { f: 'Canadian', m: 'Canadian' },
      fra: { f: 'Canadienne', m: 'Canadien' }
    },
    flag: '\uD83C\uDDE8\uD83C\uDDE6',
    maps: {
      googleMaps: 'https://goo.gl/maps/jmEVLugreeqiZXxbA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/1428125'
    },
    population: 38005238,
    gini: { 2017: 33.3 },
    fifa: 'CAN',
    car: { signs: ['CDN'], side: 'right' },
    timezones: [
      'UTC-08:00',
      'UTC-07:00',
      'UTC-06:00',
      'UTC-05:00',
      'UTC-04:00',
      'UTC-03:30'
    ],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/ca.png',
      svg: 'https://flagcdn.com/ca.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ca.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ca.svg'
    },
    startOfWeek: 'sunday',
    capitalInfo: { latlng: [45.42, -75.7] },
    postalCode: {
      format: '@#@ #@#',
      regex:
        '^([ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJKLMNPRSTVWXYZ]) ?(\\d[ABCEGHJKLMNPRSTVWXYZ]\\d)$ '
    }
  },
  {
    name: {
      common: 'Trinidad and Tobago',
      official: 'Republic of Trinidad and Tobago',
      nativeName: {
        eng: {
          official: 'Republic of Trinidad and Tobago',
          common: 'Trinidad and Tobago'
        }
      }
    },
    tld: ['.tt'],
    cca2: 'TT',
    ccn3: '780',
    cca3: 'TTO',
    cioc: 'TTO',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { TTD: { name: 'Trinidad and Tobago dollar', symbol: '$' } },
    idd: { root: '+1', suffixes: ['868'] },
    capital: ['Port of Spain'],
    altSpellings: ['TT', 'Republic of Trinidad and Tobago'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'جمهورية ترينيداد وتوباغو', common: 'ترينيداد وتوباغو' },
      bre: {
        official: 'Republik Trinidad ha Tobago',
        common: 'Trinidad ha Tobago'
      },
      ces: {
        official: 'Republika Trinidad a Tobago',
        common: 'Trinidad a Tobago'
      },
      cym: {
        official: 'Republic of Trinidad and Tobago',
        common: 'Trinidad and Tobago'
      },
      deu: {
        official: 'Republik Trinidad und Tobago',
        common: 'Trinidad und Tobago'
      },
      est: {
        official: 'Trinidadi ja Tobago Vabariik',
        common: 'Trinidad ja Tobago'
      },
      fin: {
        official: 'Trinidadin ja Tobagon tasavalta',
        common: 'Trinidad ja Tobago'
      },
      fra: {
        official: 'République de Trinité-et-Tobago',
        common: 'Trinité-et-Tobago'
      },
      hrv: {
        official: 'Republika Trinidad i Tobago',
        common: 'Trinidad i Tobago'
      },
      hun: {
        official: 'Trinidad és Tobago Köztársaság',
        common: 'Trinidad és Tobago'
      },
      ita: {
        official: 'Repubblica di Trinidad e Tobago',
        common: 'Trinidad e Tobago'
      },
      jpn: {
        official: 'トリニダード·トバゴ共和国',
        common: 'トリニダード・トバゴ'
      },
      kor: {
        official: '트리니다드 토바고 공화국',
        common: '트리니다드 토바고'
      },
      nld: {
        official: 'Republiek Trinidad en Tobago',
        common: 'Trinidad en Tobago'
      },
      per: {
        official: 'جمهوری ترینیداد و توباگو',
        common: 'ترینیداد و توباگو'
      },
      pol: { official: 'Trynidad i Tobago', common: 'Trynidad i Tobago' },
      por: {
        official: 'República de Trinidad e Tobago',
        common: 'Trinidade e Tobago'
      },
      rus: {
        official: 'Республика Тринидад и Тобаго',
        common: 'Тринидад и Тобаго'
      },
      slk: {
        official: 'Republika Trinidad a Tobaga',
        common: 'Trinidad a Tobago'
      },
      spa: {
        official: 'República de Trinidad y Tobago',
        common: 'Trinidad y Tobago'
      },
      swe: {
        official: 'Republiken Trinidad och Tobago',
        common: 'Trinidad och Tobago'
      },
      tur: { official: 'Trinidad ve Tobago', common: 'Trinidad ve Tobago' },
      urd: {
        official: 'جمہوریہ ٹرینیڈاڈ و ٹوباگو',
        common: 'ٹرینیڈاڈ و ٹوباگو'
      },
      zho: { official: '特立尼达和多巴哥共和国', common: '特立尼达和多巴哥' }
    },
    latlng: [11.0, -61.0],
    landlocked: false,
    area: 5130.0,
    demonyms: {
      eng: { f: 'Trinidadian', m: 'Trinidadian' },
      fra: { f: 'Trinidadienne', m: 'Trinidadien' }
    },
    flag: '\uD83C\uDDF9\uD83C\uDDF9',
    maps: {
      googleMaps: 'https://goo.gl/maps/NrRfDEWoG8FGZqWY7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/555717'
    },
    population: 1399491,
    gini: { 1992: 40.3 },
    fifa: 'TRI',
    car: { signs: ['TT'], side: 'left' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/tt.png',
      svg: 'https://flagcdn.com/tt.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/tt.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/tt.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [10.65, -61.52] }
  },
  {
    name: {
      common: 'Cuba',
      official: 'Republic of Cuba',
      nativeName: { spa: { official: 'República de Cuba', common: 'Cuba' } }
    },
    tld: ['.cu'],
    cca2: 'CU',
    ccn3: '192',
    cca3: 'CUB',
    cioc: 'CUB',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: {
      CUC: { name: 'Cuban convertible peso', symbol: '$' },
      CUP: { name: 'Cuban peso', symbol: '$' }
    },
    idd: { root: '+5', suffixes: ['3'] },
    capital: ['Havana'],
    altSpellings: ['CU', 'Republic of Cuba', 'República de Cuba'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { spa: 'Spanish' },
    translations: {
      ara: { official: 'جمهورية كوبا', common: 'كوبا' },
      bre: { official: 'Republik Kuba', common: 'Kuba' },
      ces: { official: 'Kubánská republika', common: 'Kuba' },
      cym: { official: 'Gweriniaeth Ciwba', common: 'Ciwba' },
      deu: { official: 'Republik Kuba', common: 'Kuba' },
      est: { official: 'Kuuba Vabariik', common: 'Kuuba' },
      fin: { official: 'Kuuban tasavalta', common: 'Kuuba' },
      fra: { official: 'République de Cuba', common: 'Cuba' },
      hrv: { official: 'Republika Kuba', common: 'Kuba' },
      hun: { official: 'Kubai Köztársaság', common: 'Kuba' },
      ita: { official: 'Repubblica di Cuba', common: 'Cuba' },
      jpn: { official: 'キューバ共和国', common: 'キューバ' },
      kor: { official: '쿠바 공화국', common: '쿠바' },
      nld: { official: 'Republiek Cuba', common: 'Cuba' },
      per: { official: 'جمهوری کوبا', common: 'کوبا' },
      pol: { official: 'Republika Kuby', common: 'Kuba' },
      por: { official: 'República de Cuba', common: 'Cuba' },
      rus: { official: 'Республика Куба', common: 'Куба' },
      slk: { official: 'Kubánska republika', common: 'Kuba' },
      spa: { official: 'República de Cuba', common: 'Cuba' },
      swe: { official: 'Republiken Kuba', common: 'Kuba' },
      tur: { official: 'Küba Cumhuriyeti', common: 'Küba' },
      urd: { official: 'جمہوریہ کیوبا', common: 'کیوبا' },
      zho: { official: '古巴共和国', common: '古巴' }
    },
    latlng: [21.5, -80.0],
    landlocked: false,
    area: 109884.0,
    demonyms: {
      eng: { f: 'Cuban', m: 'Cuban' },
      fra: { f: 'Cubaine', m: 'Cubain' }
    },
    flag: '\uD83C\uDDE8\uD83C\uDDFA',
    maps: {
      googleMaps: 'https://goo.gl/maps/1dDw1QfZspfMUTm99',
      openStreetMaps: 'https://www.openstreetmap.org/relation/307833'
    },
    population: 11326616,
    fifa: 'CUB',
    car: { signs: ['C'], side: 'right' },
    timezones: ['UTC-05:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/cu.png',
      svg: 'https://flagcdn.com/cu.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/cu.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/cu.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [23.12, -82.35] },
    postalCode: { format: 'CP #####', regex: '^(?:CP)*(\\d{5})$' }
  },
  {
    name: {
      common: 'United States Virgin Islands',
      official: 'Virgin Islands of the United States',
      nativeName: {
        eng: {
          official: 'Virgin Islands of the United States',
          common: 'United States Virgin Islands'
        }
      }
    },
    tld: ['.vi'],
    cca2: 'VI',
    ccn3: '850',
    cca3: 'VIR',
    cioc: 'ISV',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { USD: { name: 'United States dollar', symbol: '$' } },
    idd: { root: '+1', suffixes: ['340'] },
    capital: ['Charlotte Amalie'],
    altSpellings: ['VI', 'Virgin Islands, U.S.'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English' },
    translations: {
      ara: {
        official: 'جزر العذراء الامريكية',
        common: 'جزر العذراء الامريكية'
      },
      bre: {
        official: "Inizi Gwerc'h ar Stadoù-Unanet",
        common: "Inizi Gwerc'h ar Stadoù-Unanet"
      },
      ces: {
        official: 'Americké Panenské ostrovy',
        common: 'Americké Panenské ostrovy'
      },
      cym: {
        official: 'Virgin Islands of the United States',
        common: 'United States Virgin Islands'
      },
      deu: {
        official: 'Amerikanische Jungferninseln',
        common: 'Amerikanische Jungferninseln'
      },
      est: {
        official: 'Ühendriikide Neitsisaared',
        common: 'Neitsisaared, USA'
      },
      fin: { official: 'Yhdysvaltain Neitsytsaaret', common: 'Neitsytsaaret' },
      fra: {
        official: 'Îles Vierges des États-Unis',
        common: 'Îles Vierges des États-Unis'
      },
      hrv: {
        official: 'Djevičanski Otoci SAD',
        common: 'Američki Djevičanski Otoci'
      },
      hun: {
        official: 'Amerikai Virgin-szigetek',
        common: 'Amerikai Virgin-szigetek'
      },
      ita: {
        official: 'Isole Vergini degli Stati Uniti',
        common: 'Isole Vergini americane'
      },
      jpn: {
        official: '米国のバージン諸島',
        common: 'アメリカ領ヴァージン諸島'
      },
      kor: { official: '미국령 버진아일랜드', common: '미국령 버진아일랜드' },
      nld: {
        official: 'Maagdeneilanden van de Verenigde Staten',
        common: 'Amerikaanse Maagdeneilanden'
      },
      per: {
        official: 'جزایر ویرجین ایالات متحده آمریکا',
        common: 'جزایر ویرجین ایالات متحده آمریکا'
      },
      pol: {
        official: 'Wyspy Dziewicze Stanów Zjednoczonych',
        common: 'Wyspy Dziewicze Stanów Zjednoczonych'
      },
      por: {
        official: 'Ilhas Virgens dos Estados Unidos',
        common: 'Ilhas Virgens dos Estados Unidos'
      },
      rus: {
        official: 'Виргинские острова Соединенных Штатов',
        common: 'Виргинские Острова'
      },
      slk: {
        official: 'Americké Panenské ostrovy',
        common: 'Americké Panenské ostrovy'
      },
      spa: {
        official: 'Islas Vírgenes de los Estados Unidos',
        common: 'Islas Vírgenes de los Estados Unidos'
      },
      swe: {
        official: 'Amerikanska Jungfruöarna',
        common: 'Amerikanska Jungfruöarna'
      },
      tur: {
        official: 'Amerika Birleşik Devletleri Virjin Adaları',
        common: 'ABD Virjin Adaları'
      },
      urd: { official: 'امریکی جزائر ورجن', common: 'امریکی جزائر ورجن' },
      zho: { official: '美属维尔京群岛', common: '美属维尔京群岛' }
    },
    latlng: [18.35, -64.933333],
    landlocked: false,
    area: 347.0,
    demonyms: { eng: { f: 'Virgin Islander', m: 'Virgin Islander' } },
    flag: '\uD83C\uDDFB\uD83C\uDDEE',
    maps: {
      googleMaps: 'https://goo.gl/maps/mBfreywj8dor6q4m9',
      openStreetMaps: 'openstreetmap.org/relation/286898'
    },
    population: 106290,
    fifa: 'VIR',
    car: { signs: ['USA'], side: 'right' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/vi.png',
      svg: 'https://flagcdn.com/vi.svg'
    },
    coatOfArms: {},
    startOfWeek: 'monday',
    capitalInfo: { latlng: [18.35, -64.93] }
  },
  {
    name: {
      common: 'Saint Pierre and Miquelon',
      official: 'Saint Pierre and Miquelon',
      nativeName: {
        fra: {
          official: 'Collectivité territoriale de Saint-Pierre-et-Miquelon',
          common: 'Saint-Pierre-et-Miquelon'
        }
      }
    },
    tld: ['.pm'],
    cca2: 'PM',
    ccn3: '666',
    cca3: 'SPM',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { EUR: { name: 'Euro', symbol: '€' } },
    idd: { root: '+5', suffixes: ['08'] },
    capital: ['Saint-Pierre'],
    altSpellings: [
      'PM',
      'Collectivité territoriale de Saint-Pierre-et-Miquelon'
    ],
    region: 'Americas',
    subregion: 'North America',
    languages: { fra: 'French' },
    translations: {
      ara: { official: 'سان بيير وميكلون', common: 'سان بيير وميكلون' },
      bre: { official: 'Sant-Pêr-ha-Mikelon', common: 'Sant-Pêr-ha-Mikelon' },
      ces: {
        official: 'Saint-Pierre a Miquelon',
        common: 'Saint-Pierre a Miquelon'
      },
      cym: {
        official: 'Saint Pierre and Miquelon',
        common: 'Saint Pierre and Miquelon'
      },
      deu: {
        official: 'St. Pierre und Miquelon',
        common: 'St. Pierre und Miquelon'
      },
      est: {
        official: 'Saint-Pierre’i ja Miqueloni territoriaalühendus',
        common: 'Saint-Pierre ja Miquelon'
      },
      fin: {
        official: 'Saint-Pierre ja Miquelon',
        common: 'Saint-Pierre ja Miquelon'
      },
      fra: {
        official: 'Saint-Pierre-et-Miquelon',
        common: 'Saint-Pierre-et-Miquelon'
      },
      hrv: {
        official: 'Saint Pierre i Miquelon',
        common: 'Sveti Petar i Mikelon'
      },
      hun: {
        official: 'Saint-Pierre és Miquelon',
        common: 'Saint-Pierre és Miquelon'
      },
      ita: {
        official: 'Saint Pierre e Miquelon',
        common: 'Saint-Pierre e Miquelon'
      },
      jpn: {
        official: 'サンピエール島·ミクロン島',
        common: 'サンピエール島・ミクロン島'
      },
      kor: { official: '생피에르 미클롱', common: '생피에르 미클롱' },
      nld: {
        official: 'Saint-Pierre en Miquelon',
        common: 'Saint Pierre en Miquelon'
      },
      per: { official: 'سن-پیر-ا-میکلون', common: 'سن-پیِر و میکلُن' },
      pol: {
        official: 'Saint-Pierre i Miquelon',
        common: 'Saint-Pierre i Miquelon'
      },
      por: {
        official: 'Saint Pierre e Miquelon',
        common: 'Saint-Pierre e Miquelon'
      },
      rus: { official: 'Сен-Пьер и Микелон', common: 'Сен-Пьер и Микелон' },
      slk: {
        official: 'Ostrovy Saint Pierre a Miquelon',
        common: 'Saint Pierre a Miquelon'
      },
      spa: { official: 'San Pedro y Miquelón', common: 'San Pedro y Miquelón' },
      swe: {
        official: 'Saint-Pierre och Miquelon',
        common: 'Saint-Pierre och Miquelon'
      },
      tur: {
        official: 'Saint Pierre ve Miquelon',
        common: 'Saint Pierre ve Miquelon'
      },
      urd: { official: 'سینٹ پیئر و میکیلون', common: 'سینٹ پیئر و میکیلون' },
      zho: { official: '圣皮埃尔和密克隆', common: '圣皮埃尔和密克隆' }
    },
    latlng: [46.83333333, -56.33333333],
    landlocked: false,
    area: 242.0,
    demonyms: {
      eng: {
        f: 'Saint-Pierrais, Miquelonnais',
        m: 'Saint-Pierrais, Miquelonnais'
      },
      fra: {
        f: 'Saint-Pierraise, Miquelonaise',
        m: 'Saint-Pierrais, Miquelonais'
      }
    },
    flag: '\uD83C\uDDF5\uD83C\uDDF2',
    maps: {
      googleMaps: 'https://goo.gl/maps/bUM8Yc8pA8ghyhmt6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/3406826'
    },
    population: 6069,
    car: { signs: ['F'], side: 'right' },
    timezones: ['UTC-03:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/pm.png',
      svg: 'https://flagcdn.com/pm.svg'
    },
    coatOfArms: {},
    startOfWeek: 'monday',
    capitalInfo: { latlng: [46.77, -56.18] },
    postalCode: { format: '#####', regex: '^(97500)$' }
  },
  {
    name: {
      common: 'El Salvador',
      official: 'Republic of El Salvador',
      nativeName: {
        spa: { official: 'República de El Salvador', common: 'El Salvador' }
      }
    },
    tld: ['.sv'],
    cca2: 'SV',
    ccn3: '222',
    cca3: 'SLV',
    cioc: 'ESA',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { USD: { name: 'United States dollar', symbol: '$' } },
    idd: { root: '+5', suffixes: ['03'] },
    capital: ['San Salvador'],
    altSpellings: ['SV', 'Republic of El Salvador', 'República de El Salvador'],
    region: 'Americas',
    subregion: 'Central America',
    languages: { spa: 'Spanish' },
    translations: {
      ara: { official: 'جمهورية السلفادور', common: 'السلفادور' },
      bre: { official: 'Republik El Salvador', common: 'El Salvador' },
      ces: { official: 'Salvadorská republika', common: 'Salvador' },
      cym: { official: 'Gweriniaeth El Salfador', common: 'El Salfador' },
      deu: { official: 'Republik El Salvador', common: 'El Salvador' },
      est: { official: 'El Salvadori Vabariik', common: 'El Salvador' },
      fin: { official: 'El Salvadorin tasavalta', common: 'El Salvador' },
      fra: { official: 'République du Salvador', common: 'Salvador' },
      hrv: { official: 'Republika El Salvador', common: 'Salvador' },
      hun: { official: 'Salvadori Köztársaság', common: 'Salvador' },
      ita: { official: 'Repubblica di El Salvador', common: 'El Salvador' },
      jpn: { official: 'エルサルバドル共和国', common: 'エルサルバドル' },
      kor: { official: '엘살바도르 공화국', common: '엘살바도르' },
      nld: { official: 'Republiek El Salvador', common: 'El Salvador' },
      per: { official: 'جمهوری السالوادور', common: 'السالوادور' },
      pol: { official: 'Republika Salwadoru', common: 'Salwador' },
      por: { official: 'República de El Salvador', common: 'El Salvador' },
      rus: { official: 'Республика Эль-Сальвадор', common: 'Сальвадор' },
      slk: { official: 'Salvádorská republika', common: 'Salvádor' },
      spa: { official: 'República de El Salvador', common: 'El Salvador' },
      swe: { official: 'Republiken El Salvador', common: 'El Salvador' },
      tur: { official: 'El Salvador Cumhuriyeti', common: 'El Salvador' },
      urd: { official: 'جمہوریہ ایل سیلواڈور', common: 'ایل سیلواڈور' },
      zho: { official: '萨尔瓦多共和国', common: '萨尔瓦多' }
    },
    latlng: [13.83333333, -88.91666666],
    landlocked: false,
    borders: ['GTM', 'HND'],
    area: 21041.0,
    demonyms: {
      eng: { f: 'Salvadoran', m: 'Salvadoran' },
      fra: { f: 'Salvadorienne', m: 'Salvadorien' }
    },
    flag: '\uD83C\uDDF8\uD83C\uDDFB',
    maps: {
      googleMaps: 'https://goo.gl/maps/cZnCEi5sEMQtKKcB7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/1520612'
    },
    population: 6486201,
    gini: { 2019: 38.8 },
    fifa: 'SLV',
    car: { signs: ['ES'], side: 'right' },
    timezones: ['UTC-06:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/sv.png',
      svg: 'https://flagcdn.com/sv.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/sv.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/sv.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [13.7, -89.2] },
    postalCode: { format: 'CP ####', regex: '^(?:CP)*(\\d{4})$' }
  },
  {
    name: {
      common: 'Peru',
      official: 'Republic of Peru',
      nativeName: {
        aym: { official: 'Piruw Suyu', common: 'Piruw' },
        que: { official: 'Piruw Ripuwlika', common: 'Piruw' },
        spa: { official: 'República del Perú', common: 'Perú' }
      }
    },
    tld: ['.pe'],
    cca2: 'PE',
    ccn3: '604',
    cca3: 'PER',
    cioc: 'PER',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { PEN: { name: 'Peruvian sol', symbol: 'S/ ' } },
    idd: { root: '+5', suffixes: ['1'] },
    capital: ['Lima'],
    altSpellings: ['PE', 'Republic of Peru', 'República del Perú'],
    region: 'Americas',
    subregion: 'South America',
    languages: { aym: 'Aymara', que: 'Quechua', spa: 'Spanish' },
    translations: {
      ara: { official: 'جمهورية بيرو', common: 'بيرو' },
      bre: { official: 'Republik Perou', common: 'Perou' },
      ces: { official: 'Peruánská republika', common: 'Peru' },
      cym: { official: 'Republic of Peru', common: 'Peru' },
      deu: { official: 'Republik Peru', common: 'Peru' },
      est: { official: 'Peruu Vabariik', common: 'Peruu' },
      fin: { official: 'Perun tasavalta', common: 'Peru' },
      fra: { official: 'République du Pérou', common: 'Pérou' },
      hrv: { official: 'Republika Peru', common: 'Peru' },
      hun: { official: 'Perui Köztársaság', common: 'Peru' },
      ita: { official: 'Repubblica del Perù', common: 'Perù' },
      jpn: { official: 'ペルー共和国', common: 'ペルー' },
      kor: { official: '페루 공화국', common: '페루' },
      nld: { official: 'Republiek Peru', common: 'Peru' },
      per: { official: 'جمهوری پرو', common: 'پرو' },
      pol: { official: 'Republika Peru', common: 'Peru' },
      por: { official: 'República do Peru', common: 'Perú' },
      rus: { official: 'Республика Перу', common: 'Перу' },
      slk: { official: 'Peruánska republika', common: 'Peru' },
      spa: { official: 'República de Perú', common: 'Perú' },
      swe: { official: 'Republiken Peru', common: 'Peru' },
      tur: { official: 'Peru Cumhuriyeti', common: 'Peru' },
      urd: { official: 'جمہوریہ پیرو', common: 'پیرو' },
      zho: { official: '秘鲁共和国', common: '秘鲁' }
    },
    latlng: [-10.0, -76.0],
    landlocked: false,
    borders: ['BOL', 'BRA', 'CHL', 'COL', 'ECU'],
    area: 1285216.0,
    demonyms: {
      eng: { f: 'Peruvian', m: 'Peruvian' },
      fra: { f: 'Péruvienne', m: 'Péruvien' }
    },
    flag: '\uD83C\uDDF5\uD83C\uDDEA',
    maps: {
      googleMaps: 'https://goo.gl/maps/uDWEUaXNcZTng1fP6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/288247'
    },
    population: 32971846,
    gini: { 2019: 41.5 },
    fifa: 'PER',
    car: { signs: ['PE'], side: 'right' },
    timezones: ['UTC-05:00'],
    continents: ['South America'],
    flags: {
      png: 'https://flagcdn.com/w320/pe.png',
      svg: 'https://flagcdn.com/pe.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/pe.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/pe.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-12.05, -77.05] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Saint Barthélemy',
      official: 'Collectivity of Saint Barthélemy',
      nativeName: {
        fra: {
          official: 'Collectivité de Saint-Barthélemy',
          common: 'Saint-Barthélemy'
        }
      }
    },
    tld: ['.bl'],
    cca2: 'BL',
    ccn3: '652',
    cca3: 'BLM',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { EUR: { name: 'Euro', symbol: '€' } },
    idd: { root: '+5', suffixes: ['90'] },
    capital: ['Gustavia'],
    altSpellings: [
      'BL',
      'St. Barthelemy',
      'Collectivity of Saint Barthélemy',
      'Collectivité de Saint-Barthélemy'
    ],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { fra: 'French' },
    translations: {
      ara: {
        official: 'التجمع الإقليمي لسانت بارتيليمي',
        common: 'سان بارتليمي'
      },
      bre: { official: 'Saint-Barthélemy', common: 'Saint-Barthélemy' },
      ces: { official: 'Svatý Bartoloměj', common: 'Svatý Bartoloměj' },
      cym: {
        official: 'Collectivity of Saint Barthélemy',
        common: 'Saint Barthélemy'
      },
      deu: {
        official: 'Gebietskörperschaft Saint-Barthélemy',
        common: 'Saint-Barthélemy'
      },
      est: {
        official: 'Saint-Barthélemy territoriaalühendus',
        common: 'Saint-Barthélemy'
      },
      fin: {
        official: 'Saint-Barthélemyn yhteisö',
        common: 'Saint-Barthélemy'
      },
      fra: {
        official: 'Collectivité de Saint-Barthélemy',
        common: 'Saint-Barthélemy'
      },
      hrv: {
        official: 'Kolektivnost sv Barthélemy',
        common: 'Saint Barthélemy'
      },
      hun: { official: 'Saint-Barthélemy', common: 'Saint-Barthélemy' },
      ita: {
        official: 'Collettività di Saint Barthélemy',
        common: 'Antille Francesi'
      },
      jpn: {
        official: 'サン·バルテルミー島の集合体',
        common: 'サン・バルテルミー'
      },
      kor: { official: '생바르텔레미', common: '생바르텔레미' },
      nld: {
        official: 'Gemeenschap Saint Barthélemy',
        common: 'Saint Barthélemy'
      },
      per: { official: 'سن بارتلمی', common: 'سن بارتلمی' },
      pol: { official: 'Saint-Barthélemy', common: 'Saint-Barthélemy' },
      por: {
        official: 'Coletividade de Saint Barthélemy',
        common: 'São Bartolomeu'
      },
      rus: {
        official: 'Коллективность Санкт -Бартельми',
        common: 'Сен-Бартелеми'
      },
      slk: { official: 'Svätý Bartolomej', common: 'Svätý Bartolomej' },
      spa: {
        official: 'Colectividad de San Barthélemy',
        common: 'San Bartolomé'
      },
      swe: { official: 'Saint-Barthélemy', common: 'Saint-Barthélemy' },
      tur: { official: 'Saint Barthélemy', common: 'Saint Barthélemy' },
      urd: { official: 'سینٹ بارتھیملے', common: 'سینٹ بارتھیملے' },
      zho: { official: '圣巴泰勒米集体', common: '圣巴泰勒米' }
    },
    latlng: [18.5, -63.41666666],
    landlocked: false,
    area: 21.0,
    demonyms: {
      eng: { f: 'Saint Barthélemy Islander', m: 'Saint Barthélemy Islander' },
      fra: { f: 'Barthéloméenne', m: 'Barthéloméen' }
    },
    flag: '\uD83C\uDDE7\uD83C\uDDF1',
    maps: {
      googleMaps: 'https://goo.gl/maps/Mc7GqH466S7AAk297',
      openStreetMaps: 'https://www.openstreetmap.org/relation/7552779'
    },
    population: 4255,
    car: { signs: ['F'], side: 'right' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/bl.png',
      svg: 'https://flagcdn.com/bl.svg'
    },
    coatOfArms: {},
    startOfWeek: 'monday',
    capitalInfo: { latlng: [17.88, -62.85] },
    postalCode: { format: '### ###' }
  },
  {
    name: {
      common: 'Greenland',
      official: 'Greenland',
      nativeName: {
        kal: { official: 'Kalaallit Nunaat', common: 'Kalaallit Nunaat' }
      }
    },
    tld: ['.gl'],
    cca2: 'GL',
    ccn3: '304',
    cca3: 'GRL',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { DKK: { name: 'krone', symbol: 'kr.' } },
    idd: { root: '+2', suffixes: ['99'] },
    capital: ['Nuuk'],
    altSpellings: ['GL', 'Grønland'],
    region: 'Americas',
    subregion: 'North America',
    languages: { kal: 'Greenlandic' },
    translations: {
      ara: { official: 'جرينلاند', common: 'جرينلاند' },
      bre: { official: 'Greunland', common: 'Greunland' },
      ces: { official: 'Grónsko', common: 'Grónsko' },
      cym: { official: 'Greenland', common: 'Greenland' },
      deu: { official: 'Grönland', common: 'Grönland' },
      est: { official: 'Gröönimaa', common: 'Gröönimaa' },
      fin: { official: 'Groönlanti', common: 'Groönlanti' },
      fra: { official: 'Groenland', common: 'Groenland' },
      hrv: { official: 'Grenland', common: 'Grenland' },
      hun: { official: 'Grönland', common: 'Grönland' },
      ita: { official: 'Groenlandia', common: 'Groenlandia' },
      jpn: { official: 'グリーンランド', common: 'グリーンランド' },
      kor: { official: '그린란드', common: '그린란드' },
      nld: { official: 'Groenland', common: 'Groenland' },
      per: { official: 'گروئنلند', common: 'گرینلند' },
      pol: { official: 'Grenlandia', common: 'Grenlandia' },
      por: { official: 'Groenlândia', common: 'Gronelândia' },
      rus: { official: 'Гренландия', common: 'Гренландия' },
      slk: { official: 'Grónsko', common: 'Grónsko' },
      spa: { official: 'Groenlandia', common: 'Groenlandia' },
      swe: { official: 'Grönland', common: 'Grönland' },
      tur: { official: 'Grönland', common: 'Grönland' },
      urd: { official: 'گرین لینڈ', common: 'گرین لینڈ' },
      zho: { official: '格陵兰', common: '格陵兰' }
    },
    latlng: [72.0, -40.0],
    landlocked: false,
    area: 2166086.0,
    demonyms: {
      eng: { f: 'Greenlandic', m: 'Greenlandic' },
      fra: { f: 'Groenlandaise', m: 'Groenlandais' }
    },
    flag: '\uD83C\uDDEC\uD83C\uDDF1',
    maps: {
      googleMaps: 'https://goo.gl/maps/j3289UPEQXt1ceSy8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/2184073'
    },
    population: 56367,
    car: { signs: ['DK'], side: 'right' },
    timezones: ['UTC-04:00', 'UTC-03:00', 'UTC-01:00', 'UTC+00:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/gl.png',
      svg: 'https://flagcdn.com/gl.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/gl.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/gl.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [64.18, -51.75] },
    postalCode: { format: '####', regex: '^(\\d{4})$' }
  },
  {
    name: {
      common: 'Falkland Islands',
      official: 'Falkland Islands',
      nativeName: {
        eng: { official: 'Falkland Islands', common: 'Falkland Islands' }
      }
    },
    tld: ['.fk'],
    cca2: 'FK',
    ccn3: '238',
    cca3: 'FLK',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { FKP: { name: 'Falkland Islands pound', symbol: '£' } },
    idd: { root: '+5', suffixes: ['00'] },
    capital: ['Stanley'],
    altSpellings: ['FK', 'Islas Malvinas', 'Falkland Islands (Malvinas)'],
    region: 'Americas',
    subregion: 'South America',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'جزر فوكلاند', common: 'جزر فوكلاند' },
      bre: { official: 'Inizi Maloù', common: 'Inizi Maloù' },
      ces: { official: 'Falklandské ostrovy', common: 'Falklandy' },
      cym: { official: 'Falkland Islands', common: 'Falkland Islands' },
      deu: { official: 'Falklandinseln', common: 'Falklandinseln' },
      est: { official: 'Falklandi saared', common: 'Falklandi saared' },
      fin: { official: 'Falkandinsaaret', common: 'Falkandinsaaret' },
      fra: { official: 'Îles Malouines', common: 'Îles Malouines' },
      hrv: { official: 'Falklandski otoci', common: 'Falklandski Otoci' },
      hun: { official: 'Falkland-szigetek', common: 'Falkland-szigetek' },
      ita: {
        official: 'Isole Falkland',
        common: 'Isole Falkland o Isole Malvine'
      },
      jpn: {
        official: 'フォークランド',
        common: 'フォークランド（マルビナス）諸島'
      },
      kor: { official: '포클랜드 제도', common: '포클랜드 제도' },
      nld: { official: 'Falkland eilanden', common: 'Falklandeilanden' },
      per: { official: 'جزایر فالکلند', common: 'جزایر فالکلند' },
      pol: { official: 'Falklandy', common: 'Falklandy' },
      por: { official: 'Ilhas Malvinas', common: 'Ilhas Malvinas' },
      rus: { official: 'Фолклендские острова', common: 'Фолклендские острова' },
      slk: { official: 'Falklandské ostrovy', common: 'Falklandy' },
      spa: { official: 'islas Malvinas', common: 'Islas Malvinas' },
      swe: { official: 'Falklandsöarna', common: 'Falklandsöarna' },
      tur: {
        official: 'Falkland (Malvina) Adaları',
        common: 'Falkland (Malvina) Adaları'
      },
      urd: { official: 'جزائر فاکلینڈ', common: 'جزائر فاکلینڈ' },
      zho: { official: '福克兰群岛', common: '福克兰群岛' }
    },
    latlng: [-51.75, -59.0],
    landlocked: false,
    area: 12173.0,
    demonyms: {
      eng: { f: 'Falkland Islander', m: 'Falkland Islander' },
      fra: { f: 'Malouinne', m: 'Malouin' }
    },
    flag: '\uD83C\uDDEB\uD83C\uDDF0',
    maps: {
      googleMaps: 'https://goo.gl/maps/TZH1x7AGanQKifNk7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/2185374'
    },
    population: 2563,
    car: { signs: ['GB'], side: 'left' },
    timezones: ['UTC-04:00'],
    continents: ['South America'],
    flags: {
      png: 'https://flagcdn.com/w320/fk.png',
      svg: 'https://flagcdn.com/fk.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/fk.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/fk.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-51.7, -57.85] }
  },
  {
    name: {
      common: 'Saint Vincent and the Grenadines',
      official: 'Saint Vincent and the Grenadines',
      nativeName: {
        eng: {
          official: 'Saint Vincent and the Grenadines',
          common: 'Saint Vincent and the Grenadines'
        }
      }
    },
    tld: ['.vc'],
    cca2: 'VC',
    ccn3: '670',
    cca3: 'VCT',
    cioc: 'VIN',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { XCD: { name: 'Eastern Caribbean dollar', symbol: '$' } },
    idd: { root: '+1', suffixes: ['784'] },
    capital: ['Kingstown'],
    altSpellings: ['VC'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English' },
    translations: {
      ara: {
        official: 'سانت فينسنت والغرينادين',
        common: 'سانت فينسنت والغرينادين'
      },
      bre: {
        official: 'Sant-Visant hag ar Grenadinez',
        common: 'Sant-Visant hag ar Grenadinez'
      },
      ces: {
        official: 'Svatý Vincenc a Grenadiny',
        common: 'Svatý Vincenc a Grenadiny'
      },
      cym: {
        official: 'Saint Vincent and the Grenadines',
        common: 'Saint Vincent and the Grenadines'
      },
      deu: {
        official: 'St. Vincent und die Grenadinen',
        common: 'St. Vincent und die Grenadinen'
      },
      est: {
        official: 'Saint Vincent ja Grenadiinid',
        common: 'Saint Vincent'
      },
      fin: {
        official: 'Saint Vincent ja Grenadiinit',
        common: 'Saint Vincent ja Grenadiinit'
      },
      fra: {
        official: 'Saint-Vincent-et-les Grenadines',
        common: 'Saint-Vincent-et-les-Grenadines'
      },
      hrv: {
        official: 'Sveti Vincent i Grenadini',
        common: 'Sveti Vincent i Grenadini'
      },
      hun: {
        official: 'Saint Vincent és a Grenadine-szigetek',
        common: 'Saint Vincent és a Grenadine-szigetek'
      },
      ita: {
        official: 'Saint Vincent e Grenadine',
        common: 'Saint Vincent e Grenadine'
      },
      jpn: {
        official: 'セントビンセントおよびグレナディーン諸島',
        common: 'セントビンセントおよびグレナディーン諸島'
      },
      kor: {
        official: '세인트빈센트 그레나딘',
        common: '세인트빈센트 그레나딘'
      },
      nld: {
        official: 'Saint Vincent en de Grenadines',
        common: 'Saint Vincent en de Grenadines'
      },
      per: {
        official: 'سنت وینسنت و گرنادین‌ها',
        common: 'سنت وینسنت و گرنادین‌ها'
      },
      pol: {
        official: 'Saint Vincent i Grenadyny',
        common: 'Saint Vincent i Grenadyny'
      },
      por: {
        official: 'São Vicente e Granadinas',
        common: 'São Vincente e Granadinas'
      },
      rus: {
        official: 'Сент-Винсент и Гренадины',
        common: 'Сент-Винсент и Гренадины'
      },
      slk: {
        official: 'Svätý Vincent a Grenadíny',
        common: 'Svätý Vincent a Grenadíny'
      },
      spa: {
        official: 'San Vicente y las Granadinas',
        common: 'San Vicente y Granadinas'
      },
      swe: {
        official: 'Saint Vincent och Grenadinerna',
        common: 'Saint Vincent och Grenadinerna'
      },
      tur: {
        official: 'Saint Vincent ve Grenadinler',
        common: 'Saint Vincent ve Grenadinler'
      },
      urd: {
        official: 'سینٹ وینسینٹ و گریناڈائنز',
        common: 'سینٹ وینسینٹ و گریناڈائنز'
      },
      zho: { official: '圣文森特和格林纳丁斯', common: '圣文森特和格林纳丁斯' }
    },
    latlng: [13.25, -61.2],
    landlocked: false,
    area: 389.0,
    demonyms: {
      eng: { f: 'Saint Vincentian', m: 'Saint Vincentian' },
      fra: { f: 'Vincentaise', m: 'Vincentais' }
    },
    flag: '\uD83C\uDDFB\uD83C\uDDE8',
    maps: {
      googleMaps: 'https://goo.gl/maps/wMbnMqjG37FMnrwf7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/550725'
    },
    population: 110947,
    fifa: 'VIN',
    car: { signs: ['WV'], side: 'left' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/vc.png',
      svg: 'https://flagcdn.com/vc.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/vc.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/vc.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [13.13, -61.22] }
  },
  {
    name: {
      common: 'United States Minor Outlying Islands',
      official: 'United States Minor Outlying Islands',
      nativeName: {
        eng: {
          official: 'United States Minor Outlying Islands',
          common: 'United States Minor Outlying Islands'
        }
      }
    },
    tld: ['.us'],
    cca2: 'UM',
    ccn3: '581',
    cca3: 'UMI',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { USD: { name: 'United States dollar', symbol: '$' } },
    idd: { root: '+2', suffixes: ['68'] },
    capital: ['Washington DC'],
    altSpellings: ['UM'],
    region: 'Americas',
    subregion: 'North America',
    languages: { eng: 'English' },
    translations: {
      ara: {
        official: 'جزر الولايات المتحدة الصغيرة النائية',
        common: 'جزر الولايات المتحدة الصغيرة النائية'
      },
      bre: {
        official: 'Inizi Minor A-bell Stadoù-Unanet',
        common: 'Inizi Minor A-bell Stadoù-Unanet'
      },
      ces: {
        official: 'Menší odlehlé ostrovy Spojených států amerických',
        common: 'Menší odlehlé ostrovy USA'
      },
      cym: {
        official: 'United States Minor Outlying Islands',
        common: 'United States Minor Outlying Islands'
      },
      deu: {
        official: 'USA, kleinere ausgelagerte Inseln',
        common: 'Kleinere Inselbesitzungen der Vereinigten Staaten'
      },
      est: {
        official: 'Ühendriikide väikesed hajasaared',
        common: 'Ühendriikide hajasaared'
      },
      fin: {
        official: 'Yhdysvaltain asumattomat saaret',
        common: 'Yhdysvaltain asumattomat saaret'
      },
      fra: {
        official: 'Îles mineures éloignées des États-Unis',
        common: 'Îles mineures éloignées des États-Unis'
      },
      hrv: {
        official: 'Mali udaljeni otoci SAD-a',
        common: 'Mali udaljeni otoci SAD-a'
      },
      hun: {
        official: 'Az Amerikai Egyesült Államok lakatlan külbirtokai',
        common: 'Az Amerikai Egyesült Államok lakatlan külbirtokai'
      },
      ita: {
        official: 'Stati Uniti Isole Minori',
        common: "Isole minori esterne degli Stati Uniti d'America"
      },
      jpn: { official: 'アメリカ合衆国外諸島', common: '合衆国領有小離島' },
      kor: { official: '미국령 군소 제도', common: '미국령 군소 제도' },
      nld: {
        official: 'Kleine afgelegen eilanden van de Verenigde Staten',
        common: 'Kleine afgelegen eilanden van de Verenigde Staten'
      },
      per: {
        official: 'جزایر کوچک حاشیه‌ای ایالات متحده آمریکا',
        common: 'جزایر کوچک حاشیه‌ای ایالات متحده آمریکا'
      },
      pol: {
        official: 'Dalekie Wyspy Mniejsze Stanów Zjednoczonych',
        common: 'Dalekie Wyspy Mniejsze Stanów Zjednoczonych'
      },
      por: {
        official: 'Estados Unidos Ilhas Menores Distantes',
        common: 'Ilhas Menores Distantes dos Estados Unidos'
      },
      rus: {
        official: 'Внешние малые острова США',
        common: 'Внешние малые острова США'
      },
      slk: {
        official: 'Menšie odľahlé ostrovy Spjoených štátov',
        common: 'Menšie odľahlé ostrovy USA'
      },
      spa: {
        official: 'Estados Unidos Islas menores alejadas de',
        common: 'Islas Ultramarinas Menores de Estados Unidos'
      },
      swe: {
        official: 'Förenta staternas mindre öar i Oceanien och Västindien',
        common: 'Förenta staternas mindre öar i Oceanien och Västindien'
      },
      tur: {
        official: 'Amerika Birleşik Devletleri Küçük Dış Adaları',
        common: 'Amerika Birleşik Devletleri Küçük Dış Adaları'
      },
      urd: {
        official: 'امریکی چھوٹے بیرونی جزائر',
        common: 'امریکی چھوٹے بیرونی جزائر'
      },
      zho: { official: '美国本土外小岛屿', common: '美国本土外小岛屿' }
    },
    latlng: [19.3, 166.633333],
    landlocked: false,
    area: 34.2,
    demonyms: { eng: { f: 'American Islander', m: 'American Islander' } },
    flag: '\uD83C\uDDFA\uD83C\uDDF2',
    maps: {
      googleMaps: 'https://goo.gl/maps/hZKnrzgeK69dDyPF8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/6430384'
    },
    population: 300,
    car: { signs: [''], side: 'right' },
    timezones: ['UTC-11:00', 'UTC-10:00', 'UTC+12:00'],
    continents: ['Oceania'],
    flags: {
      png: 'https://flagcdn.com/w320/um.png',
      svg: 'https://flagcdn.com/um.svg'
    },
    coatOfArms: {},
    startOfWeek: 'monday',
    capitalInfo: {}
  },
  {
    name: {
      common: 'Panama',
      official: 'Republic of Panama',
      nativeName: { spa: { official: 'República de Panamá', common: 'Panamá' } }
    },
    tld: ['.pa'],
    cca2: 'PA',
    ccn3: '591',
    cca3: 'PAN',
    cioc: 'PAN',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: {
      PAB: { name: 'Panamanian balboa', symbol: 'B/.' },
      USD: { name: 'United States dollar', symbol: '$' }
    },
    idd: { root: '+5', suffixes: ['07'] },
    capital: ['Panama City'],
    altSpellings: ['PA', 'Republic of Panama', 'República de Panamá'],
    region: 'Americas',
    subregion: 'Central America',
    languages: { spa: 'Spanish' },
    translations: {
      ara: { official: 'جمهورية بنما', common: 'بنما' },
      bre: { official: 'Republik Panama', common: 'Panama' },
      ces: { official: 'Panamská republika', common: 'Panama' },
      cym: { official: 'Republic of Panama', common: 'Panama' },
      deu: { official: 'Republik Panama', common: 'Panama' },
      est: { official: 'Panama Vabariik', common: 'Panama' },
      fin: { official: 'Panaman tasavalta', common: 'Panama' },
      fra: { official: 'République du Panama', common: 'Panama' },
      hrv: { official: 'Republika Panama', common: 'Panama' },
      hun: { official: 'Panamai Köztársaság', common: 'Panama' },
      ita: { official: 'Repubblica di Panama', common: 'Panama' },
      jpn: { official: 'パナマ共和国', common: 'パナマ' },
      kor: { official: '파나마 공화국', common: '파나마' },
      nld: { official: 'Republiek Panama', common: 'Panama' },
      per: { official: 'جمهوری پاناما', common: 'پاناما' },
      pol: { official: 'Republika Panamy', common: 'Panama' },
      por: { official: 'República do Panamá', common: 'Panamá' },
      rus: { official: 'Республика Панама', common: 'Панама' },
      slk: { official: 'Panamská republika', common: 'Panama' },
      spa: { official: 'República de Panamá', common: 'Panamá' },
      swe: { official: 'Republiken Panama', common: 'Panama' },
      tur: { official: 'Panama Cumhuriyeti', common: 'Panama' },
      urd: { official: 'جمہوریہ پاناما', common: 'پاناما' },
      zho: { official: '巴拿马共和国', common: '巴拿马' }
    },
    latlng: [9.0, -80.0],
    landlocked: false,
    borders: ['COL', 'CRI'],
    area: 75417.0,
    demonyms: {
      eng: { f: 'Panamanian', m: 'Panamanian' },
      fra: { f: 'Panaméenne', m: 'Panaméen' }
    },
    flag: '\uD83C\uDDF5\uD83C\uDDE6',
    maps: {
      googleMaps: 'https://goo.gl/maps/sEN7sKqeawa5oPNLA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/287668'
    },
    population: 4314768,
    gini: { 2019: 49.8 },
    fifa: 'PAN',
    car: { signs: ['PA'], side: 'right' },
    timezones: ['UTC-05:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/pa.png',
      svg: 'https://flagcdn.com/pa.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/pa.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/pa.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [8.97, -79.53] }
  },
  {
    name: {
      common: 'Uruguay',
      official: 'Oriental Republic of Uruguay',
      nativeName: {
        spa: { official: 'República Oriental del Uruguay', common: 'Uruguay' }
      }
    },
    tld: ['.uy'],
    cca2: 'UY',
    ccn3: '858',
    cca3: 'URY',
    cioc: 'URU',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { UYU: { name: 'Uruguayan peso', symbol: '$' } },
    idd: { root: '+5', suffixes: ['98'] },
    capital: ['Montevideo'],
    altSpellings: [
      'UY',
      'Oriental Republic of Uruguay',
      'República Oriental del Uruguay'
    ],
    region: 'Americas',
    subregion: 'South America',
    languages: { spa: 'Spanish' },
    translations: {
      ara: { official: 'جمهورية الأوروغواي الشرقية', common: 'الأوروغواي' },
      bre: { official: 'Republik Reter Uruguay', common: 'Uruguay' },
      ces: { official: 'Uruguayská východní republika', common: 'Uruguay' },
      cym: { official: 'Oriental Republic of Uruguay', common: 'Uruguay' },
      deu: { official: 'Republik Östlich des Uruguay', common: 'Uruguay' },
      est: { official: 'Uruguay Idavabariik', common: 'Uruguay' },
      fin: { official: 'Uruguayn itäinen tasavalta', common: 'Uruguay' },
      fra: { official: "République orientale de l'Uruguay", common: 'Uruguay' },
      hrv: { official: 'Orijentalna Republika Urugvaj', common: 'Urugvaj' },
      hun: { official: 'Uruguayi Keleti Köztársaság', common: 'Uruguay' },
      ita: { official: "Repubblica Orientale dell'Uruguay", common: 'Uruguay' },
      jpn: { official: 'ウルグアイ東方共和国', common: 'ウルグアイ' },
      kor: { official: '우루과이 동방 공화국', common: '우루과이' },
      nld: { official: 'Oosterse Republiek Uruguay', common: 'Uruguay' },
      per: { official: 'جمهوری اروگوئه', common: 'اروگوئه' },
      pol: { official: 'Wschodnia Republika Urugwaju', common: 'Urugwaj' },
      por: { official: 'República Oriental do Uruguai', common: 'Uruguai' },
      rus: { official: 'Восточной Республики Уругвай', common: 'Уругвай' },
      slk: { official: 'Uruguajská východná republika', common: 'Uruguaj' },
      spa: { official: 'República Oriental del Uruguay', common: 'Uruguay' },
      swe: { official: 'Republiken Uruguay', common: 'Uruguay' },
      tur: { official: 'Uruguay Doğu Cumhuriyeti', common: 'Uruguay' },
      urd: { official: 'جمہوریہ شرقیہ یوراگوئے', common: 'یوراگوئے' },
      zho: { official: '乌拉圭东岸共和国', common: '乌拉圭' }
    },
    latlng: [-33.0, -56.0],
    landlocked: false,
    borders: ['ARG', 'BRA'],
    area: 181034.0,
    demonyms: {
      eng: { f: 'Uruguayan', m: 'Uruguayan' },
      fra: { f: 'Uruguayenne', m: 'Uruguayen' }
    },
    flag: '\uD83C\uDDFA\uD83C\uDDFE',
    maps: {
      googleMaps: 'https://goo.gl/maps/tiQ9Baekb1jQtDSD9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/287072'
    },
    population: 3473727,
    gini: { 2019: 39.7 },
    fifa: 'URU',
    car: { signs: ['ROU'], side: 'right' },
    timezones: ['UTC-03:00'],
    continents: ['South America'],
    flags: {
      png: 'https://flagcdn.com/w320/uy.png',
      svg: 'https://flagcdn.com/uy.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/uy.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/uy.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-34.85, -56.17] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Ecuador',
      official: 'Republic of Ecuador',
      nativeName: {
        spa: { official: 'República del Ecuador', common: 'Ecuador' }
      }
    },
    tld: ['.ec'],
    cca2: 'EC',
    ccn3: '218',
    cca3: 'ECU',
    cioc: 'ECU',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { USD: { name: 'United States dollar', symbol: '$' } },
    idd: { root: '+5', suffixes: ['93'] },
    capital: ['Quito'],
    altSpellings: ['EC', 'Republic of Ecuador', 'República del Ecuador'],
    region: 'Americas',
    subregion: 'South America',
    languages: { spa: 'Spanish' },
    translations: {
      ara: { official: 'جمهورية الإكوادور', common: 'الإكوادور' },
      bre: { official: 'Republik Ecuador', common: 'Ecuador' },
      ces: { official: 'Ekvádorská republika', common: 'Ekvádor' },
      cym: { official: 'Gweriniaeth Ecwador', common: 'Ecwador' },
      deu: { official: 'Republik Ecuador', common: 'Ecuador' },
      est: { official: 'Ecuadori Vabariik', common: 'Ecuador' },
      fin: { official: 'Ecuadorin tasavalta', common: 'Ecuador' },
      fra: { official: "République de l'Équateur", common: 'Équateur' },
      hrv: { official: 'Republika Ekvador', common: 'Ekvador' },
      hun: { official: 'Ecuadori Köztársaság', common: 'Ecuador' },
      ita: { official: "Repubblica dell'Ecuador", common: 'Ecuador' },
      jpn: { official: 'エクアドル共和国', common: 'エクアドル' },
      kor: { official: '에콰도르 공화국', common: '에콰도르' },
      nld: { official: 'Republiek Ecuador', common: 'Ecuador' },
      per: { official: 'جمهوری اکوادور', common: 'اکوادور' },
      pol: { official: 'Ekwador', common: 'Ekwador' },
      por: { official: 'República do Equador', common: 'Equador' },
      rus: { official: 'Республика Эквадор', common: 'Эквадор' },
      slk: { official: 'Ekvádorská republika', common: 'Ekvádor' },
      spa: { official: 'República del Ecuador', common: 'Ecuador' },
      swe: { official: 'Republiken Ecuador', common: 'Ecuador' },
      tur: { official: 'Ekvador Cumhuriyeti', common: 'Ekvador' },
      urd: { official: 'جمہوریہ ایکوڈور', common: 'ایکواڈور' },
      zho: { official: '厄瓜多尔共和国', common: '厄瓜多尔' }
    },
    latlng: [-2.0, -77.5],
    landlocked: false,
    borders: ['COL', 'PER'],
    area: 276841.0,
    demonyms: {
      eng: { f: 'Ecuadorean', m: 'Ecuadorean' },
      fra: { f: 'Équatorienne', m: 'Équatorien' }
    },
    flag: '\uD83C\uDDEA\uD83C\uDDE8',
    maps: {
      googleMaps: 'https://goo.gl/maps/TbX8hUW4gcbRPZiK7',
      openStreetMaps: 'https://www.openstreetmap.org/relation/108089'
    },
    population: 17643060,
    gini: { 2019: 45.7 },
    fifa: 'ECU',
    car: { signs: ['EC'], side: 'right' },
    timezones: ['UTC-06:00', 'UTC-05:00'],
    continents: ['South America'],
    flags: {
      png: 'https://flagcdn.com/w320/ec.png',
      svg: 'https://flagcdn.com/ec.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ec.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ec.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-0.22, -78.5] },
    postalCode: { format: '@####@', regex: '^([a-zA-Z]\\d{4}[a-zA-Z])$' }
  },
  {
    name: {
      common: 'Guyana',
      official: 'Co-operative Republic of Guyana',
      nativeName: {
        eng: { official: 'Co-operative Republic of Guyana', common: 'Guyana' }
      }
    },
    tld: ['.gy'],
    cca2: 'GY',
    ccn3: '328',
    cca3: 'GUY',
    cioc: 'GUY',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { GYD: { name: 'Guyanese dollar', symbol: '$' } },
    idd: { root: '+5', suffixes: ['92'] },
    capital: ['Georgetown'],
    altSpellings: ['GY', 'Co-operative Republic of Guyana'],
    region: 'Americas',
    subregion: 'South America',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'جمهورية غيانا التعاونية', common: 'غيانا' },
      bre: { official: 'Republik Kevelourel Gwiana', common: 'Guyana' },
      ces: { official: 'Kooperativní republika Guyana', common: 'Guyana' },
      cym: { official: 'Co-operative Republic of Guyana', common: 'Guyana' },
      deu: { official: 'Kooperative Republik Guyana', common: 'Guyana' },
      est: { official: 'Guyana Vabariik', common: 'Guyana' },
      fin: {
        official: 'Guayanan osuustoiminnallinen tasavalta',
        common: 'Guayana'
      },
      fra: { official: 'République coopérative de Guyana', common: 'Guyana' },
      hrv: { official: 'Zadruga Republika Gvajana', common: 'Gvajana' },
      hun: { official: 'Guyanai Szövetkezeti Köztársaság', common: 'Guyana' },
      ita: { official: 'Co -operative Republic of Guyana', common: 'Guyana' },
      jpn: { official: 'ガイアナの協同共和国', common: 'ガイアナ' },
      kor: { official: '가이아나 협동 공화국', common: '가이아나' },
      nld: { official: 'Coöperatieve Republiek Guyana', common: 'Guyana' },
      per: { official: 'جمهوری تعاونی گویان', common: 'گویان' },
      pol: { official: 'Kooperacyjna Republika Gujany', common: 'Gujana' },
      por: { official: 'Co -operative República da Guiana', common: 'Guiana' },
      rus: { official: 'Кооперативная Республика Гайана', common: 'Гайана' },
      slk: { official: 'Guyanská kooperatívna republika', common: 'Guyana' },
      spa: { official: 'República Cooperativa de Guyana', common: 'Guyana' },
      swe: { official: 'Kooperativa republiken Guyana', common: 'Guyana' },
      tur: { official: 'Guyana Kooperatif Cumhuriyeti', common: 'Guyana' },
      urd: { official: 'تعاونی جمہوریہ گیانا', common: 'گیانا' },
      zho: { official: '圭亚那共和国', common: '圭亚那' }
    },
    latlng: [5.0, -59.0],
    landlocked: false,
    borders: ['BRA', 'SUR', 'VEN'],
    area: 214969.0,
    demonyms: {
      eng: { f: 'Guyanese', m: 'Guyanese' },
      fra: { f: 'Guyanienne', m: 'Guyanien' }
    },
    flag: '\uD83C\uDDEC\uD83C\uDDFE',
    maps: {
      googleMaps: 'https://goo.gl/maps/DFsme2xEeugUAsCx5',
      openStreetMaps: 'https://www.openstreetmap.org/relation/287083'
    },
    population: 786559,
    gini: { 1998: 45.1 },
    fifa: 'GUY',
    car: { signs: ['GUY'], side: 'left' },
    timezones: ['UTC-04:00'],
    continents: ['South America'],
    flags: {
      png: 'https://flagcdn.com/w320/gy.png',
      svg: 'https://flagcdn.com/gy.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/gy.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/gy.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [6.8, -58.15] }
  },
  {
    name: {
      common: 'Curaçao',
      official: 'Country of Curaçao',
      nativeName: {
        eng: { official: 'Country of Curaçao', common: 'Curaçao' },
        nld: { official: 'Land Curaçao', common: 'Curaçao' },
        pap: { official: 'Pais Kòrsou', common: 'Pais Kòrsou' }
      }
    },
    tld: ['.cw'],
    cca2: 'CW',
    ccn3: '531',
    cca3: 'CUW',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { ANG: { name: 'Netherlands Antillean guilder', symbol: 'ƒ' } },
    idd: { root: '+5', suffixes: ['99'] },
    capital: ['Willemstad'],
    altSpellings: [
      'CW',
      'Curacao',
      'Kòrsou',
      'Country of Curaçao',
      'Land Curaçao',
      'Pais Kòrsou'
    ],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English', nld: 'Dutch', pap: 'Papiamento' },
    translations: {
      ara: { official: 'دولة كوراساو', common: 'كوراساو' },
      bre: { official: 'Bro Curaçao', common: 'Curaçao' },
      ces: { official: 'Autonomní země Curaçao', common: 'Curaçao' },
      cym: { official: 'Country of Curaçao', common: 'Curaçao' },
      deu: { official: 'Land Curaçao', common: 'Curaçao' },
      est: { official: 'Curaçao', common: 'Curaçao' },
      fin: { official: 'Curaçao', common: 'Curaçao' },
      fra: { official: 'Pays de Curaçao', common: 'Curaçao' },
      hun: { official: 'Curaçao', common: 'Curaçao' },
      ita: { official: 'Paese di Curaçao', common: 'Curaçao' },
      kor: { official: '퀴라소', common: '퀴라소' },
      nld: { official: 'Land Curaçao', common: 'Curaçao' },
      per: { official: 'کوراسائو', common: 'کوراسائو' },
      pol: { official: 'Curaçao', common: 'Curaçao' },
      por: { official: 'País de Curaçao', common: 'ilha da Curação' },
      rus: { official: 'Страна Кюрасао', common: 'Кюрасао' },
      slk: { official: 'Curacao', common: 'Curacao' },
      spa: { official: 'País de Curazao', common: 'Curazao' },
      swe: { official: 'Curaçao', common: 'Curaçao' },
      tur: { official: 'Curaçao', common: 'Curaçao' },
      urd: { official: 'مملکتِ کیوراساؤ', common: 'کیوراساؤ' },
      zho: { official: '库拉索', common: '库拉索' }
    },
    latlng: [12.116667, -68.933333],
    landlocked: false,
    area: 444.0,
    demonyms: {
      eng: { f: 'Curaçaoan', m: 'Curaçaoan' },
      fra: { f: 'Curacienne', m: 'Curacien' }
    },
    flag: '\uD83C\uDDE8\uD83C\uDDFC',
    maps: {
      googleMaps: 'https://goo.gl/maps/9D3hTeA3qKaRT7S16',
      openStreetMaps: 'https://www.openstreetmap.org/relation/1216719'
    },
    population: 155014,
    fifa: 'CUW',
    car: { signs: ['CW'], side: 'right' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/cw.png',
      svg: 'https://flagcdn.com/cw.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/cw.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/cw.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [12.1, -68.92] }
  },
  {
    name: {
      common: 'Bolivia',
      official: 'Plurinational State of Bolivia',
      nativeName: {
        aym: { official: 'Wuliwya Suyu', common: 'Wuliwya' },
        grn: { official: 'Tetã Volívia', common: 'Volívia' },
        que: { official: 'Buliwya Mamallaqta', common: 'Buliwya' },
        spa: { official: 'Estado Plurinacional de Bolivia', common: 'Bolivia' }
      }
    },
    tld: ['.bo'],
    cca2: 'BO',
    ccn3: '068',
    cca3: 'BOL',
    cioc: 'BOL',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { BOB: { name: 'Bolivian boliviano', symbol: 'Bs.' } },
    idd: { root: '+5', suffixes: ['91'] },
    capital: ['Sucre'],
    altSpellings: [
      'BO',
      'Buliwya',
      'Wuliwya',
      'Bolivia, Plurinational State of',
      'Plurinational State of Bolivia',
      'Estado Plurinacional de Bolivia',
      'Buliwya Mamallaqta',
      'Wuliwya Suyu',
      'Tetã Volívia'
    ],
    region: 'Americas',
    subregion: 'South America',
    languages: {
      aym: 'Aymara',
      grn: 'Guaraní',
      que: 'Quechua',
      spa: 'Spanish'
    },
    translations: {
      ara: { official: 'دولة بوليفيا المتعددة القوميات', common: 'بوليفيا' },
      bre: { official: 'Stad Liesvroadel Bolivia', common: 'Bolivia' },
      ces: { official: 'Mnohonárodnostní stát Bolívie', common: 'Bolívie' },
      cym: { official: 'Gweriniaeth Bolifia', common: 'Bolifia' },
      deu: { official: 'Plurinationaler Staat Bolivien', common: 'Bolivien' },
      est: { official: 'Boliivia Paljurahvuseline Riik', common: 'Boliivia' },
      fin: { official: 'Bolivian monikansainen valtio', common: 'Bolivia' },
      fra: { official: 'État plurinational de Bolivie', common: 'Bolivie' },
      hrv: { official: 'Plurinational State of Bolivia', common: 'Bolivija' },
      hun: { official: 'Bolíviai Többnemzetiségű Állam', common: 'Bolívia' },
      ita: {
        official: 'Stato Plurinazionale della Bolivia',
        common: 'Bolivia'
      },
      jpn: { official: 'ボリビアの多民族国', common: 'ボリビア多民族国' },
      kor: { official: '볼리비아 다민족국', common: '볼리비아' },
      nld: { official: 'Plurinationale Staat van Bolivia', common: 'Bolivia' },
      per: { official: 'جمهوری بولیوی', common: 'بولیوی' },
      pol: { official: 'Wielonarodowe Państwo Boliwia', common: 'Boliwia' },
      por: { official: 'Estado Plurinacional da Bolívia', common: 'Bolívia' },
      rus: {
        official: 'Многонациональное Государство Боливия',
        common: 'Боливия'
      },
      slk: { official: 'Bolívijská republika', common: 'Bolívia' },
      spa: { official: 'Estado Plurinacional de Bolivia', common: 'Bolivia' },
      swe: { official: 'Mångnationella staten Bolivia', common: 'Bolivia' },
      tur: { official: 'Bolivya Çokuluslu Devleti', common: 'Bolivya' },
      urd: { official: 'جمہوریہ بولیویا', common: 'بولیویا' },
      zho: { official: '多民族玻利维亚国', common: '玻利维亚' }
    },
    latlng: [-17.0, -65.0],
    landlocked: true,
    borders: ['ARG', 'BRA', 'CHL', 'PRY', 'PER'],
    area: 1098581.0,
    demonyms: {
      eng: { f: 'Bolivian', m: 'Bolivian' },
      fra: { f: 'Bolivienne', m: 'Bolivien' }
    },
    flag: '\uD83C\uDDE7\uD83C\uDDF4',
    maps: {
      googleMaps: 'https://goo.gl/maps/9DfnyfbxNM2g5U9b9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/252645'
    },
    population: 11673029,
    gini: { 2019: 41.6 },
    fifa: 'BOL',
    car: { signs: ['BOL'], side: 'right' },
    timezones: ['UTC-04:00'],
    continents: ['South America'],
    flags: {
      png: 'https://flagcdn.com/w320/bo.png',
      svg: 'https://flagcdn.com/bo.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/bo.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/bo.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [-19.02, -65.26] }
  },
  {
    name: {
      common: 'Martinique',
      official: 'Martinique',
      nativeName: { fra: { official: 'Martinique', common: 'Martinique' } }
    },
    tld: ['.mq'],
    cca2: 'MQ',
    ccn3: '474',
    cca3: 'MTQ',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { EUR: { name: 'Euro', symbol: '€' } },
    idd: { root: '+5', suffixes: ['96'] },
    capital: ['Fort-de-France'],
    altSpellings: ['MQ'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { fra: 'French' },
    translations: {
      ara: { official: 'مارتينيك', common: 'مارتينيك' },
      bre: { official: 'Martinik', common: 'Martinik' },
      ces: { official: 'Martinik', common: 'Martinik' },
      cym: { official: 'Martinique', common: 'Martinique' },
      deu: { official: 'Martinique', common: 'Martinique' },
      est: { official: 'Martinique’i departemang', common: 'Martinique' },
      fin: { official: 'Martinique', common: 'Martinique' },
      fra: { official: 'Martinique', common: 'Martinique' },
      hrv: { official: 'Martinique', common: 'Martinique' },
      hun: { official: 'Martinique', common: 'Martinique' },
      ita: { official: 'Martinique', common: 'Martinica' },
      jpn: { official: 'マルティニーク島', common: 'マルティニーク' },
      kor: { official: '마르티니크', common: '마르티니크' },
      nld: { official: 'Martinique', common: 'Martinique' },
      per: { official: 'مارتینیک', common: 'مارتینیک' },
      pol: { official: 'Martynika', common: 'Martynika' },
      por: { official: 'Martinique', common: 'Martinica' },
      rus: { official: 'Мартиника', common: 'Мартиника' },
      slk: { official: 'Martinique', common: 'Martinique' },
      spa: { official: 'Martinica', common: 'Martinica' },
      swe: { official: 'Martinique', common: 'Martinique' },
      tur: { official: 'Martinik', common: 'Martinik' },
      urd: { official: 'مارٹینیک', common: 'مارٹینیک' },
      zho: { official: '马提尼克', common: '马提尼克' }
    },
    latlng: [14.666667, -61.0],
    landlocked: false,
    area: 1128.0,
    demonyms: {
      eng: { f: 'Martinican', m: 'Martinican' },
      fra: { f: 'Martiniquaise', m: 'Martiniquais' }
    },
    flag: '\uD83C\uDDF2\uD83C\uDDF6',
    maps: {
      googleMaps: 'https://goo.gl/maps/87ER7sDAFU7JjcvR6',
      openStreetMaps: 'https://www.openstreetmap.org/relation/2473088'
    },
    population: 378243,
    car: { signs: ['F'], side: 'right' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/mq.png',
      svg: 'https://flagcdn.com/mq.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/mq.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/mq.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [14.6, -61.08] },
    postalCode: { format: '#####', regex: '^(\\d{5})$' }
  },
  {
    name: {
      common: 'Saint Lucia',
      official: 'Saint Lucia',
      nativeName: { eng: { official: 'Saint Lucia', common: 'Saint Lucia' } }
    },
    tld: ['.lc'],
    cca2: 'LC',
    ccn3: '662',
    cca3: 'LCA',
    cioc: 'LCA',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { XCD: { name: 'Eastern Caribbean dollar', symbol: '$' } },
    idd: { root: '+1', suffixes: ['758'] },
    capital: ['Castries'],
    altSpellings: ['LC'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'سانت لوسيا', common: 'سانت لوسيا' },
      bre: { official: 'Santez-Lusia', common: 'Santez-Lusia' },
      ces: { official: 'Svatá Lucie', common: 'Svatá Lucie' },
      cym: { official: 'Saint Lucia', common: 'Saint Lucia' },
      deu: { official: 'St. Lucia', common: 'St. Lucia' },
      est: { official: 'Saint Lucia', common: 'Saint Lucia' },
      fin: { official: 'Saint Lucia', common: 'Saint Lucia' },
      fra: { official: 'Sainte-Lucie', common: 'Sainte-Lucie' },
      hrv: { official: 'Sveta Lucija', common: 'Sveta Lucija' },
      hun: { official: 'Saint Lucia', common: 'Saint Lucia' },
      ita: { official: 'Santa Lucia', common: 'Santa Lucia' },
      jpn: { official: 'セントルシア', common: 'セントルシア' },
      kor: { official: '세인트루시아', common: '세인트루시아' },
      nld: { official: 'Saint Lucia', common: 'Saint Lucia' },
      per: { official: 'سنت لوسیا', common: 'سنت لوسیا' },
      pol: { official: 'Saint Lucia', common: 'Saint Lucia' },
      por: { official: 'Santa Lúcia', common: 'Santa Lúcia' },
      rus: { official: 'Сент-Люсия', common: 'Сент-Люсия' },
      slk: { official: 'Svätá Lucia', common: 'Svätá Lucia' },
      spa: { official: 'Santa Lucía', common: 'Santa Lucía' },
      swe: { official: 'Saint Lucia', common: 'Saint Lucia' },
      tur: { official: 'Saint Lucia', common: 'Saint Lucia' },
      urd: { official: 'سینٹ لوسیا', common: 'سینٹ لوسیا' },
      zho: { official: '圣卢西亚', common: '圣卢西亚' }
    },
    latlng: [13.88333333, -60.96666666],
    landlocked: false,
    area: 616.0,
    demonyms: {
      eng: { f: 'Saint Lucian', m: 'Saint Lucian' },
      fra: { f: 'Saint-Lucienne', m: 'Saint-Lucien' }
    },
    flag: '\uD83C\uDDF1\uD83C\uDDE8',
    maps: {
      googleMaps: 'https://goo.gl/maps/4HhJ2jkPdSL9BPRcA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/550728'
    },
    population: 183629,
    gini: { 2016: 51.2 },
    fifa: 'LCA',
    car: { signs: ['WL'], side: 'left' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/lc.png',
      svg: 'https://flagcdn.com/lc.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/lc.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/lc.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [14.0, -61.0] }
  },
  {
    name: {
      common: 'Bermuda',
      official: 'Bermuda',
      nativeName: { eng: { official: 'Bermuda', common: 'Bermuda' } }
    },
    tld: ['.bm'],
    cca2: 'BM',
    ccn3: '060',
    cca3: 'BMU',
    cioc: 'BER',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { BMD: { name: 'Bermudian dollar', symbol: '$' } },
    idd: { root: '+1', suffixes: ['441'] },
    capital: ['Hamilton'],
    altSpellings: [
      'BM',
      'The Islands of Bermuda',
      'The Bermudas',
      'Somers Isles'
    ],
    region: 'Americas',
    subregion: 'North America',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'برمودا', common: 'برمودا' },
      bre: { official: 'Bermuda', common: 'Bermuda' },
      ces: { official: 'Bermudské ostrovy', common: 'Bermudy' },
      cym: { official: 'Bermiwda', common: 'Bermiwda' },
      deu: { official: 'Bermuda', common: 'Bermuda' },
      est: { official: 'Bermuda', common: 'Bermuda' },
      fin: { official: 'Bermuda', common: 'Bermuda' },
      fra: { official: 'Bermudes', common: 'Bermudes' },
      hrv: { official: 'Bermuda', common: 'Bermudi' },
      hun: { official: 'Bermuda', common: 'Bermuda' },
      ita: { official: 'Bermuda', common: 'Bermuda' },
      jpn: { official: 'バミューダ', common: 'バミューダ' },
      kor: { official: '버뮤다', common: '버뮤다' },
      nld: { official: 'Bermuda', common: 'Bermuda' },
      per: { official: 'جزایر برمودا', common: 'برمودا' },
      pol: { official: 'Bermudy', common: 'Bermudy' },
      por: { official: 'Bermudas', common: 'Bermudas' },
      rus: { official: 'Бермудские острова', common: 'Бермудские Острова' },
      slk: { official: 'Bermudy', common: 'Bermudy' },
      spa: { official: 'Bermuda', common: 'Bermudas' },
      swe: { official: 'Bermuda', common: 'Bermuda' },
      tur: { official: 'Bermuda', common: 'Bermuda' },
      urd: { official: 'برمودا', common: 'برمودا' },
      zho: { official: '百慕大', common: '百慕大' }
    },
    latlng: [32.33333333, -64.75],
    landlocked: false,
    area: 54.0,
    demonyms: {
      eng: { f: 'Bermudian', m: 'Bermudian' },
      fra: { f: 'Bermudienne', m: 'Bermudien' }
    },
    flag: '\uD83C\uDDE7\uD83C\uDDF2',
    maps: {
      googleMaps: 'https://goo.gl/maps/NLsRGNjTzDghTtAJA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/1993208'
    },
    population: 63903,
    fifa: 'BER',
    car: { signs: ['GB'], side: 'left' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/bm.png',
      svg: 'https://flagcdn.com/bm.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/bm.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/bm.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [32.28, -64.78] },
    postalCode: { format: '@@ ##', regex: '^([A-Z]{2}\\d{2})$' }
  },
  {
    name: {
      common: 'Grenada',
      official: 'Grenada',
      nativeName: { eng: { official: 'Grenada', common: 'Grenada' } }
    },
    tld: ['.gd'],
    cca2: 'GD',
    ccn3: '308',
    cca3: 'GRD',
    cioc: 'GRN',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { XCD: { name: 'Eastern Caribbean dollar', symbol: '$' } },
    idd: { root: '+1', suffixes: ['473'] },
    capital: ["St. George's"],
    altSpellings: ['GD'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'غرينادا', common: 'غرينادا' },
      bre: { official: 'Grenada', common: 'Grenada' },
      ces: { official: 'Grenada', common: 'Grenada' },
      cym: { official: 'Grenada', common: 'Grenada' },
      deu: { official: 'Grenada', common: 'Grenada' },
      est: { official: 'Grenada', common: 'Grenada' },
      fin: { official: 'Grenada', common: 'Grenada' },
      fra: { official: 'Grenade', common: 'Grenade' },
      hrv: { official: 'Grenada', common: 'Grenada' },
      hun: { official: 'Grenada', common: 'Grenada' },
      ita: { official: 'Grenada', common: 'Grenada' },
      jpn: { official: 'グレナダ', common: 'グレナダ' },
      kor: { official: '그레나다', common: '그레나다' },
      nld: { official: 'Grenada', common: 'Grenada' },
      per: { official: 'گرنادا', common: 'گرنادا' },
      pol: { official: 'Grenada', common: 'Grenada' },
      por: { official: 'Grenada', common: 'Granada' },
      rus: { official: 'Гренада', common: 'Гренада' },
      slk: { official: 'Grenada', common: 'Grenada' },
      spa: { official: 'Granada', common: 'Grenada' },
      swe: { official: 'Grenada', common: 'Grenada' },
      tur: { official: 'Grenada', common: 'Grenada' },
      urd: { official: 'گریناڈا', common: 'گریناڈا' },
      zho: { official: '格林纳达', common: '格林纳达' }
    },
    latlng: [12.11666666, -61.66666666],
    landlocked: false,
    area: 344.0,
    demonyms: {
      eng: { f: 'Grenadian', m: 'Grenadian' },
      fra: { f: 'Grenadienne', m: 'Grenadien' }
    },
    flag: '\uD83C\uDDEC\uD83C\uDDE9',
    maps: {
      googleMaps: 'https://goo.gl/maps/rqWyfUAt4xhvk1Zy9',
      openStreetMaps: 'https://www.openstreetmap.org/relation/550727'
    },
    population: 112519,
    fifa: 'GRN',
    car: { signs: ['WG'], side: 'left' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/gd.png',
      svg: 'https://flagcdn.com/gd.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/gd.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/gd.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [32.38, -64.68] }
  },
  {
    name: {
      common: 'Puerto Rico',
      official: 'Commonwealth of Puerto Rico',
      nativeName: {
        eng: { official: 'Commonwealth of Puerto Rico', common: 'Puerto Rico' },
        spa: {
          official: 'Estado Libre Asociado de Puerto Rico',
          common: 'Puerto Rico'
        }
      }
    },
    tld: ['.pr'],
    cca2: 'PR',
    ccn3: '630',
    cca3: 'PRI',
    cioc: 'PUR',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { USD: { name: 'United States dollar', symbol: '$' } },
    idd: { root: '+1', suffixes: ['787', '939'] },
    capital: ['San Juan'],
    altSpellings: [
      'PR',
      'Commonwealth of Puerto Rico',
      'Estado Libre Asociado de Puerto Rico'
    ],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English', spa: 'Spanish' },
    translations: {
      ara: { official: 'كومنولث بويرتوريكو', common: 'بويرتوريكو' },
      bre: { official: 'Kenglad Puerto Rico', common: 'Puerto Rico' },
      ces: { official: 'Portoriko', common: 'Portoriko' },
      cym: { official: 'Commonwealth of Puerto Rico', common: 'Puerto Rico' },
      deu: { official: 'Freistaat Puerto Rico', common: 'Puerto Rico' },
      est: { official: 'Puerto Rico Ühendus', common: 'Puerto Rico' },
      fin: { official: 'Puerto Rico', common: 'Puerto Rico' },
      fra: { official: 'Porto Rico', common: 'Porto Rico' },
      hrv: { official: 'Zajednica Puerto Rico', common: 'Portoriko' },
      hun: { official: 'Puerto Rico', common: 'Puerto Rico' },
      ita: { official: 'Commonwealth di Porto Rico', common: 'Porto Rico' },
      jpn: { official: 'プエルトリコのコモンウェルス', common: 'プエルトリコ' },
      kor: { official: '푸에르토리코', common: '푸에르토리코' },
      nld: { official: 'Gemenebest van Puerto Rico', common: 'Puerto Rico' },
      per: { official: 'قلمرو همسود پورتوریکو', common: 'پورتوریکو' },
      pol: {
        official: 'Wolne Stowarzyszone Państwo Portoryko',
        common: 'Portoryko'
      },
      por: { official: 'Commonwealth of Puerto Rico', common: 'Porto Rico' },
      rus: { official: 'Содружество Пуэрто-Рико', common: 'Пуэрто-Рико' },
      slk: { official: 'Portorické spoločenstvo', common: 'Portoriko' },
      spa: { official: 'Asociado de Puerto Rico', common: 'Puerto Rico' },
      swe: { official: 'Puerto Rico', common: 'Puerto Rico' },
      tur: { official: 'Porto Riko Topluluğu', common: 'Porto Riko' },
      urd: { official: ' دولتِ مشترکہ پورٹو ریکو', common: 'پورٹو ریکو' },
      zho: { official: '波多黎各联邦', common: '波多黎各' }
    },
    latlng: [18.25, -66.5],
    landlocked: false,
    area: 8870.0,
    demonyms: {
      eng: { f: 'Puerto Rican', m: 'Puerto Rican' },
      fra: { f: 'Portoricaine', m: 'Portoricain' }
    },
    flag: '\uD83C\uDDF5\uD83C\uDDF7',
    maps: {
      googleMaps: 'https://goo.gl/maps/sygfDbtwn389wu8x5',
      openStreetMaps: 'https://www.openstreetmap.org/relation/4422604'
    },
    population: 3194034,
    fifa: 'PUR',
    car: { signs: ['USA'], side: 'right' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/pr.png',
      svg: 'https://flagcdn.com/pr.svg'
    },
    coatOfArms: {},
    startOfWeek: 'monday',
    capitalInfo: { latlng: [18.47, -66.12] },
    postalCode: { format: '#####-####', regex: '^(\\d{9})$' }
  },
  {
    name: {
      common: 'Jamaica',
      official: 'Jamaica',
      nativeName: {
        eng: { official: 'Jamaica', common: 'Jamaica' },
        jam: { official: 'Jamaica', common: 'Jamaica' }
      }
    },
    tld: ['.jm'],
    cca2: 'JM',
    ccn3: '388',
    cca3: 'JAM',
    cioc: 'JAM',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: { JMD: { name: 'Jamaican dollar', symbol: '$' } },
    idd: { root: '+1', suffixes: ['876'] },
    capital: ['Kingston'],
    altSpellings: ['JM'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English', jam: 'Jamaican Patois' },
    translations: {
      ara: { official: 'جامايكا', common: 'جامايكا' },
      bre: { official: 'Jamaika', common: 'Jamaika' },
      ces: { official: 'Jamajka', common: 'Jamajka' },
      cym: { official: 'Jamaica', common: 'Jamaica' },
      deu: { official: 'Jamaika', common: 'Jamaika' },
      est: { official: 'Jamaica', common: 'Jamaica' },
      fin: { official: 'Jamaika', common: 'Jamaika' },
      fra: { official: 'Jamaïque', common: 'Jamaïque' },
      hrv: { official: 'Jamajka', common: 'Jamajka' },
      hun: { official: 'Jamaica', common: 'Jamaica' },
      ita: { official: 'Giamaica', common: 'Giamaica' },
      jpn: { official: 'ジャマイカ', common: 'ジャマイカ' },
      kor: { official: '자메이카', common: '자메이카' },
      nld: { official: 'Jamaica', common: 'Jamaica' },
      per: { official: 'جامائیکا', common: 'جامائیکا' },
      pol: { official: 'Jamajka', common: 'Jamajka' },
      por: { official: 'Jamaica', common: 'Jamaica' },
      rus: { official: 'Ямайка', common: 'Ямайка' },
      slk: { official: 'Jamajka', common: 'Jamajka' },
      spa: { official: 'Jamaica', common: 'Jamaica' },
      swe: { official: 'Jamaica', common: 'Jamaica' },
      tur: { official: 'Jamaika', common: 'Jamaika' },
      urd: { official: 'جمیکا', common: 'جمیکا' },
      zho: { official: '牙买加', common: '牙买加' }
    },
    latlng: [18.25, -77.5],
    landlocked: false,
    area: 10991.0,
    demonyms: {
      eng: { f: 'Jamaican', m: 'Jamaican' },
      fra: { f: 'Jamaïcaine', m: 'Jamaïcain' }
    },
    flag: '\uD83C\uDDEF\uD83C\uDDF2',
    maps: {
      googleMaps: 'https://goo.gl/maps/Z8mQ6jxnRQKFwJy9A',
      openStreetMaps: 'https://www.openstreetmap.org/relation/555017'
    },
    population: 2961161,
    gini: { 2004: 45.5 },
    fifa: 'JAM',
    car: { signs: ['JA'], side: 'left' },
    timezones: ['UTC-05:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/jm.png',
      svg: 'https://flagcdn.com/jm.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/jm.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/jm.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [17.99702, -76.79358] }
  },
  {
    name: {
      common: 'Aruba',
      official: 'Aruba',
      nativeName: {
        nld: { official: 'Aruba', common: 'Aruba' },
        pap: { official: 'Aruba', common: 'Aruba' }
      }
    },
    tld: ['.aw'],
    cca2: 'AW',
    ccn3: '533',
    cca3: 'ABW',
    cioc: 'ARU',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { AWG: { name: 'Aruban florin', symbol: 'ƒ' } },
    idd: { root: '+2', suffixes: ['97'] },
    capital: ['Oranjestad'],
    altSpellings: ['AW'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { nld: 'Dutch', pap: 'Papiamento' },
    translations: {
      ara: { official: 'أروبا', common: 'أروبا' },
      bre: { official: 'Aruba', common: 'Aruba' },
      ces: { official: 'Aruba', common: 'Aruba' },
      cym: { official: 'Aruba', common: 'Aruba' },
      deu: { official: 'Aruba', common: 'Aruba' },
      est: { official: 'Aruba', common: 'Aruba' },
      fin: { official: 'Aruba', common: 'Aruba' },
      fra: { official: 'Aruba', common: 'Aruba' },
      hrv: { official: 'Aruba', common: 'Aruba' },
      hun: { official: 'Aruba', common: 'Aruba' },
      ita: { official: 'Aruba', common: 'Aruba' },
      jpn: { official: 'アルバ', common: 'アルバ' },
      kor: { official: '아루바', common: '아루바' },
      nld: { official: 'Aruba', common: 'Aruba' },
      per: { official: 'آروبا', common: 'آروبا' },
      pol: { official: 'Aruba', common: 'Aruba' },
      por: { official: 'Aruba', common: 'Aruba' },
      rus: { official: 'Аруба', common: 'Аруба' },
      slk: { official: 'Aruba', common: 'Aruba' },
      spa: { official: 'Aruba', common: 'Aruba' },
      swe: { official: 'Aruba', common: 'Aruba' },
      tur: { official: 'Aruba', common: 'Aruba' },
      urd: { official: 'اروبا', common: 'اروبا' },
      zho: { official: '阿鲁巴', common: '阿鲁巴' }
    },
    latlng: [12.5, -69.96666666],
    landlocked: false,
    area: 180.0,
    demonyms: {
      eng: { f: 'Aruban', m: 'Aruban' },
      fra: { f: 'Arubaise', m: 'Arubais' }
    },
    flag: '\uD83C\uDDE6\uD83C\uDDFC',
    maps: {
      googleMaps: 'https://goo.gl/maps/8hopbQqifHAgyZyg8',
      openStreetMaps: 'https://www.openstreetmap.org/relation/1231749'
    },
    population: 106766,
    fifa: 'ARU',
    car: { side: 'right' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/aw.png',
      svg: 'https://flagcdn.com/aw.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/aw.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/aw.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [12.52, -70.03] }
  },
  {
    name: {
      common: 'Montserrat',
      official: 'Montserrat',
      nativeName: { eng: { official: 'Montserrat', common: 'Montserrat' } }
    },
    tld: ['.ms'],
    cca2: 'MS',
    ccn3: '500',
    cca3: 'MSR',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { XCD: { name: 'Eastern Caribbean dollar', symbol: '$' } },
    idd: { root: '+1', suffixes: ['664'] },
    capital: ['Plymouth'],
    altSpellings: ['MS'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'مونتسرات', common: 'مونتسرات' },
      bre: { official: 'Montserrat', common: 'Montserrat' },
      ces: { official: 'Montserrat', common: 'Montserrat' },
      cym: { official: 'Montserrat', common: 'Montserrat' },
      deu: { official: 'Montserrat', common: 'Montserrat' },
      est: { official: 'Montserrat', common: 'Montserrat' },
      fin: { official: 'Montserrat', common: 'Montserrat' },
      fra: { official: 'Montserrat', common: 'Montserrat' },
      hrv: { official: 'Montserrat', common: 'Montserrat' },
      hun: { official: 'Montserrat', common: 'Montserrat' },
      ita: { official: 'Montserrat', common: 'Montserrat' },
      jpn: { official: 'モントセラト', common: 'モントセラト' },
      kor: { official: '몬트세랫', common: '몬트세랫' },
      nld: { official: 'Montserrat', common: 'Montserrat' },
      per: { official: 'مونتسرات', common: 'مونتسرات' },
      pol: { official: 'Montserrat', common: 'Montserrat' },
      por: { official: 'Montserrat', common: 'Montserrat' },
      rus: { official: 'Монтсеррат', common: 'Монтсеррат' },
      slk: { official: 'Montserrat', common: 'Montserrat' },
      spa: { official: 'Montserrat', common: 'Montserrat' },
      swe: { official: 'Montserrat', common: 'Montserrat' },
      tur: { official: 'Montserrat', common: 'Montserrat' },
      urd: { official: 'مانٹسریٹ', common: 'مانٹسریٹ' },
      zho: { official: '蒙特塞拉特', common: '蒙特塞拉特' }
    },
    latlng: [16.75, -62.2],
    landlocked: false,
    area: 102.0,
    demonyms: {
      eng: { f: 'Montserratian', m: 'Montserratian' },
      fra: { f: 'Montserratienne', m: 'Montserratien' }
    },
    flag: '\uD83C\uDDF2\uD83C\uDDF8',
    maps: {
      googleMaps: 'https://goo.gl/maps/CSbe7UmxPmiwQB7GA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/537257'
    },
    population: 4922,
    fifa: 'MSR',
    car: { signs: ['GB'], side: 'left' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/ms.png',
      svg: 'https://flagcdn.com/ms.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/ms.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/ms.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [16.7, -62.22] }
  },
  {
    name: {
      common: 'Sint Maarten',
      official: 'Sint Maarten',
      nativeName: {
        eng: { official: 'Sint Maarten', common: 'Sint Maarten' },
        fra: { official: 'Saint-Martin', common: 'Saint-Martin' },
        nld: { official: 'Sint Maarten', common: 'Sint Maarten' }
      }
    },
    tld: ['.sx'],
    cca2: 'SX',
    ccn3: '534',
    cca3: 'SXM',
    independent: false,
    status: 'officially-assigned',
    unMember: false,
    currencies: { ANG: { name: 'Netherlands Antillean guilder', symbol: 'ƒ' } },
    idd: { root: '+1', suffixes: ['721'] },
    capital: ['Philipsburg'],
    altSpellings: ['SX', 'Sint Maarten (Dutch part)'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English', fra: 'French', nld: 'Dutch' },
    translations: {
      ara: { official: 'سينت مارتن', common: 'سينت مارتن' },
      bre: { official: 'Sint Maarten', common: 'Sint Maarten' },
      ces: { official: 'Svatý Martin', common: 'Svatý Martin (Nizozemsko)' },
      cym: { official: 'Sint Maarten', common: 'Sint Maarten' },
      deu: { official: 'Sint Maarten', common: 'Sint Maarten' },
      est: { official: 'Sint Maarten', common: 'Sint Maarten' },
      fin: { official: 'Sint Maarten', common: 'Sint Maarten' },
      fra: { official: 'Sint Maarten', common: 'Saint-Martin' },
      hrv: { official: 'Sveti Martin', common: 'Sveti Martin' },
      hun: { official: 'Sint Maarten', common: 'Sint Maarten' },
      ita: { official: 'Sint Maarten', common: 'Sint Maarten' },
      jpn: { official: 'シントマールテン島', common: 'シント・マールテン' },
      kor: { official: '신트마르턴', common: '신트마르턴' },
      nld: { official: 'Sint Maarten', common: 'Sint Maarten' },
      per: { official: 'سن مارتن', common: 'سن مارتن' },
      pol: { official: 'Sint Maarten', common: 'Sint Maarten' },
      por: { official: 'Sint Maarten', common: 'São Martinho' },
      rus: { official: 'Синт-Маартен', common: 'Синт-Мартен' },
      slk: { official: 'Sint Maarten', common: 'Sint Maarten' },
      spa: { official: 'Sint Maarten', common: 'Sint Maarten' },
      swe: { official: 'Sint Maarten', common: 'Sint Maarten' },
      tur: { official: 'Sint Maarten', common: 'Sint Maarten' },
      urd: { official: 'سنٹ مارٹن', common: 'سنٹ مارٹن' },
      zho: { official: '圣马丁岛', common: '圣马丁岛' }
    },
    latlng: [18.033333, -63.05],
    landlocked: false,
    borders: ['MAF'],
    area: 34.0,
    demonyms: {
      eng: { f: 'St. Maartener', m: 'St. Maartener' },
      fra: { f: 'Saint-Martinoise', m: 'Saint-Martinois' }
    },
    flag: '\uD83C\uDDF8\uD83C\uDDFD',
    maps: {
      googleMaps: 'https://goo.gl/maps/DjvcESy1a1oGEZuNA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/1231790'
    },
    population: 40812,
    car: { signs: ['SX'], side: 'right' },
    timezones: ['UTC-04:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/sx.png',
      svg: 'https://flagcdn.com/sx.svg'
    },
    coatOfArms: {},
    startOfWeek: 'monday',
    capitalInfo: { latlng: [18.02, -63.03] }
  },
  {
    name: {
      common: 'Bahamas',
      official: 'Commonwealth of the Bahamas',
      nativeName: {
        eng: { official: 'Commonwealth of the Bahamas', common: 'Bahamas' }
      }
    },
    tld: ['.bs'],
    cca2: 'BS',
    ccn3: '044',
    cca3: 'BHS',
    cioc: 'BAH',
    independent: true,
    status: 'officially-assigned',
    unMember: true,
    currencies: {
      BSD: { name: 'Bahamian dollar', symbol: '$' },
      USD: { name: 'United States dollar', symbol: '$' }
    },
    idd: { root: '+1', suffixes: ['242'] },
    capital: ['Nassau'],
    altSpellings: ['BS', 'Commonwealth of the Bahamas'],
    region: 'Americas',
    subregion: 'Caribbean',
    languages: { eng: 'English' },
    translations: {
      ara: { official: 'كومنولث جزر البهاما', common: 'باهاماس' },
      bre: { official: 'Kenglad ar Bahamas', common: 'Bahamas' },
      ces: { official: 'Bahamské společenství', common: 'Bahamy' },
      cym: { official: 'Cymanwlad y Bahamas', common: 'Bahamas' },
      deu: { official: 'Commonwealth der Bahamas', common: 'Bahamas' },
      est: { official: 'Bahama Ühendus', common: 'Bahama' },
      fin: { official: 'Bahaman liittovaltio', common: 'Bahamasaaret' },
      fra: { official: 'Commonwealth des Bahamas', common: 'Bahamas' },
      hrv: { official: 'Zajednica Bahama', common: 'Bahami' },
      hun: { official: 'Bahamai Közösség', common: 'Bahama-szigetek' },
      ita: { official: 'Commonwealth delle Bahamas', common: 'Bahamas' },
      jpn: { official: 'バハマ', common: 'バハマ' },
      kor: { official: '바하마 연방', common: '바하마' },
      nld: { official: "Gemenebest van de Bahama's", common: 'Bahama’s' },
      per: { official: 'قلمرو همسود باهاما', common: 'باهاما' },
      pol: { official: 'Bahamy', common: 'Bahamy' },
      por: { official: 'Comunidade das Bahamas', common: 'Bahamas' },
      rus: {
        official: 'Содружество Багамских Островов',
        common: 'Багамские Острова'
      },
      slk: { official: 'Bahamské spoločenstvo', common: 'Bahamy' },
      spa: { official: 'Commonwealth de las Bahamas', common: 'Bahamas' },
      swe: { official: 'Samväldet Bahamas', common: 'Bahamas' },
      tur: { official: 'Bahama Milletler Topluluğu', common: 'Bahamalar' },
      urd: { official: 'دولتِ مشترکہ بہاماس', common: 'بہاماس' },
      zho: { official: '巴哈马联邦', common: '巴哈马' }
    },
    latlng: [24.25, -76.0],
    landlocked: false,
    area: 13943.0,
    demonyms: {
      eng: { f: 'Bahamian', m: 'Bahamian' },
      fra: { f: 'Bahamienne', m: 'Bahamien' }
    },
    flag: '\uD83C\uDDE7\uD83C\uDDF8',
    maps: {
      googleMaps: 'https://goo.gl/maps/1YzRs1BZrG8p8pmVA',
      openStreetMaps: 'https://www.openstreetmap.org/relation/547469'
    },
    population: 393248,
    fifa: 'BAH',
    car: { signs: ['BS'], side: 'left' },
    timezones: ['UTC-05:00'],
    continents: ['North America'],
    flags: {
      png: 'https://flagcdn.com/w320/bs.png',
      svg: 'https://flagcdn.com/bs.svg'
    },
    coatOfArms: {
      png: 'https://mainfacts.com/media/images/coats_of_arms/bs.png',
      svg: 'https://mainfacts.com/media/images/coats_of_arms/bs.svg'
    },
    startOfWeek: 'monday',
    capitalInfo: { latlng: [25.08, -77.35] }
  }
]
